const translations = {
  fr: {
    // Navigation
    home:              'Accueil',
    pokedex:           '📋 Pokédex',
    miniGames:         '🎮 Mini-Jeux',
    tactics:           '⚔️ Tactics',

    // Page d'accueil
    welcome:           'Bienvenue, Dresseur',
    welcomeTrainer:    'Bienvenu {trainer} !',
    subtitle:          'Capturez, combattez et explorez le monde Pokémon.\nVotre aventure commence ici.',
    launchSafari:      'Lancer PokeWordle',
    openPokedex:       'Ouvrir le Pokédex',

    // HomeStats
    availablePokemons: 'Pokémon disponibles',
    legendaries:       'Légendaires',
    generations:       'Générations',
    miniGamesLabel:    'Mini-jeux',

    // HomePokemonOfDay
    pokemonOfDay:      'Pokémon du Jour',
    dailyRenewal:      'Renouvellement quotidien',

    // Type
    types: {
      fire: 'Feu', water: 'Eau', grass: 'Plante', electric: 'Électrik',
      psychic: 'Psy', ice: 'Glace', dragon: 'Dragon', dark: 'Ténèbres',
      fairy: 'Fée', normal: 'Normal', fighting: 'Combat', flying: 'Vol',
      poison: 'Poison', ground: 'Sol', rock: 'Roche', bug: 'Insecte',
      ghost: 'Spectre', steel: 'Acier'
    },

    // FicheStrategique — général
    ficheTitle:        'Fiche Stratégique de',
    recommendedRole:   'Rôle recommandé',
    natureBuild:       'Nature',
    evsBuild:          'EVs',
    itemBuild:         'Objet',
    weaknesses:        'Faiblesses',
    resistances:       'Résistances',
    immunities:        'Immunités',

    // FicheStrategique — tiers
    tierUberDesc:      'Légendaire dominant',
    tierOUDesc:        'Très compétitif',
    tierUUDesc:        'Compétitif solide',
    tierRUDesc:        'Usage régional',
    tierNUDesc:        'Accessible à tous',

    // FicheStrategique — rôles
    roleAttack:        'Attaquant Physique',
    roleSpAtk:         'Attaquant Spécial',
    roleDefense:       'Mur Physique',
    roleSpDef:         'Mur Spécial',
    roleSpeed:         'Sweeper Rapide',
    roleHp:            'Tank Général',

    // FicheStrategique — natures
    natureJovial:      'Jovial (+Atq)',
    natureModeste:     'Modeste (+Atq.Sp)',
    natureImpudent:    'Impudent (+Déf.)',
    natureDoux:        'Doux (+Déf.Sp)',
    natureTimide:      'Timide (+Vit.)',
    naturePrudent:     'Prudent (+Déf.Sp)',

    // FicheStrategique — items
    itemCeinture:      'Ceinture-Choix',
    itemLunette:       'Lunette-Choix',
    itemRestes:        'Restes',
    itemFoulard:       'Foulard-Choix',

    // FicheStrategique — stats
    statHp:            'PV',
    statAtk:           'ATQ',
    statDef:           'DEF',
    statSpAtk:         'ATQ.SP',
    statSpDef:         'DEF.SP',
    statSpeed:         'VIT',

    // Home Stats
    navHome: 'Accueil',
    navPokedex: 'Pokédex',
    navGames: 'Mini-jeux',
    navLegendaries: 'Légendaires',

    // Home Features
    featuresTitle: 'Choisissez votre Aventure',
    featuresSubtitle: 'Plusieurs façons d\'explorer le monde Pokémon',
    featureSafari: 'Safari Zone',
    featureSafariDesc: 'Capturez des Pokémon sauvages, construisez votre équipe et affrontez des Boss légendaires.',
    featurePokedex: 'Pokédex',
    featurePokedexDesc: 'Explorez la base de données complète des 1000+ Pokémon avec stats, types et évolutions.',
    featureQuiz: 'Quiz Pokémon',
    featureQuizDesc: 'Testez vos connaissances ! Silhouettes, cris, types… Saurez-vous tous les reconnaître ?',
    featureTeamBuilder: 'Team Builder',
    featureTeamBuilderDesc: 'Construisez et optimisez votre équipe compétitive avec analyse des types et synergies.',
    featureSafariBadge: 'IDLE RPG',
    featurePokedexBadge: 'ENCYCLOPÉDIE',
    featureComingSoon: 'BIENTÔT',
    featurePlay: 'Découvrir',
    featureSafariStats: 'Capture & Combat',
    featurePokedexStats: '1000+ Pokémon',
    featureQuizStats: 'Devinettes & Score',
    featureTeamStats: 'Stratégie',

    // Home Pokedex View
    pokedexPreviewTitle: 'Aperçu du Pokédex',
    pokedexPreviewSubtitle: '{count} Pokémon vous attendent',
    pokedexPreviewButton: 'Voir les {count} Pokémon',

    historyTitle : 'Historique',
    continueButton : 'Rejouer',
    defeatTitle : 'Défaite',
    pointsGained: 'Points +{points}',
    victoryTitle: 'Victoire',

    pokedexKeys: {

      // GenerationNav
      selectGeneration: 'Sélectionnez une génération',
      allGenerations: 'Toutes',

      // SearchBar  
      searchPokemon: 'Rechercher un Pokémon...',
      noPokemonFound: 'Aucun Pokémon trouvé',

      // FilterBar
      filterType: 'Type',
      filterColor: 'Couleur', 
      sortBy: 'Trier par',
      sortNumber: 'Numéro (ID)',
      sortNameAsc: 'Nom (A-Z)',
      sortNameDesc: 'Nom (Z-A)',
      sortTotalStatsDesc: 'Stats totales (↓)',
      sortTotalStatsAsc: 'Stats totales (↑)',
      sortHpDesc: 'PV (↓)',
      sortHpAsc: 'PV (↑)',
      sortAttackDesc: 'Attaque (↓)',
      sortAttackAsc: 'Attaque (↑)',
      sortDefenseDesc: 'Défense (↓)',
      sortDefenseAsc: 'Défense (↑)',
      sortSpAtkDesc: 'Atq. Spé. (↓)',
      sortSpAtkAsc: 'Atq. Spé. (↑)',
      sortSpDefDesc: 'Déf. Spé. (↓)',
      sortSpDefAsc: 'Déf. Spé. (↑)',
      sortSpeedDesc: 'Vitesse (↓)',
      sortSpeedAsc: 'Vitesse (↑)',

      // Types pour FilterBar (déjà partiellement dans votre fichier)
      normal: 'Normal', fire: 'Feu', water: 'Eau', grass: 'Plante',
      electric: 'Électrik', ice: 'Glace', fighting: 'Combat', 
      poison: 'Poison', ground: 'Sol', flying: 'Vol', psychic: 'Psy',
      bug: 'Insecte', rock: 'Roche', ghost: 'Spectre', dragon: 'Dragon',
      dark: 'Ténèbres', steel: 'Acier', fairy: 'Fée',

      // Couleurs
      black: 'Noir', blue: 'Bleu', brown: 'Marron', gray: 'Gris',
      green: 'Vert', pink: 'Rose', purple: 'Violet', red: 'Rouge',
      white: 'Blanc', yellow: 'Jaune'
    },

    gameModes: 'Modes de Jeu',
    gameSubtitle: 'Testez vos connaissances Pokémon !',
    
    shadow: 'Silhouette',
    shadowDesc: 'Devinez le Pokémon depuis son ombre floue',
    
    description: 'Description',
    
    type: 'Types',
    typeDesc: 'Trouvez tous les types par élimination',
    
    hangman: 'Pendu',
    hangmanDesc: 'Pendu classique avec noms Pokémon',
    
    memory: 'Mémoire',
    memoryDesc: "Associez les paires Pokémon",
    
    higherLower: 'Plus ou Moins',
    higherLowerDesc: 'Devinez quel Pokémon est le plus lourd',
    
    typeChallenge: 'Défi Types',
    typeChallengeDesc: 'Identifiez les types sous pression temporelle',
    
    safariZone: 'Zone Safari',
    safariZoneDesc: 'Clicker idle & constructeur d\'équipe',
    
    descriptionDesc: 'Description indisponible',
    Quitter: 'Quitter',
    Score: 'Score',
    Essais: 'Essais',
    Valider: 'Valider',
    Continuer: 'Continuer',
    Rejouer: 'Rejouer',

    quitButton: 'Quitter',
    scoreLabel: 'Score',
    attemptsLabel: 'Essais',
    higherLowerTitle: 'Plus ou Moins ?',
    heavierButton: 'Plus lourd',
    lighterButton: 'Plus léger',
    vs: 'VS',
    retryButton: 'Rejouer',
    memoryTitle: 'Mémoire Pokémon',
    pairsLabel: 'Paires',
    shadowTitle: 'Silhouette',
    typeGameTitle: 'Trouvez les Types',
    toFind: 'à trouver',
    validateButton: 'Valider',
    loading: 'Chargement...',
    searchPokemon: 'Nom du Pokémon...',
    arcadeRetry: 'Réessayez',
    timeUpMessage: 'Temps écoulé ! Votre score : {score}',
    typeQuestionPrefix: 'Quel type est ',
    weightUnit: 'kg',

    classicGameDesc: 'Un Pokémon mystère se cache ! Devine-le en tapant des noms. Chaque tentative te donne des indices : type, génération, couleur, taille… Plus tu es proche, plus les cases s\'allument !',

    fp: {
      loading: 'Chargement complet...',
      error:   'Impossible de charger les données.',

      tab: {
        stats:      'Stats',
        moves:      'Capacités',
        sprites:    'Sprites',
        evolution:  'Évolution',
        pokedex:    'Pokédex',
        encounters: 'Rencontres',
        languages:  'Langues',
      },

      stat: {
        hp:               'PV',
        attack:           'Attaque',
        defense:          'Défense',
        'special-attack': 'Att. Spé.',
        'special-defense':'Déf. Spé.',
        speed:            'Vitesse',
        total:            'Total',
      },

      qi: {
        height:         'Taille',
        weight:         'Poids',
        baseExp:        'Exp. de base',
        captureRate:    'Taux capture',
        baseHappiness:  'Bonheur base',
        growthRate:     'Croissance',
        hatchSteps:     'Pas de ponte',
        hatchStepsValue:'{steps} pas',
        gender:         'Genre',
        color:          'Couleur',
        shape:          'Forme',
        habitat:        'Habitat',
        generation:     'Génération',
        evolvesFrom:    'Évolue de',
        genderDiff:     'Différences sexuelles',
        switchableForms:'Formes échangeables',
        yes:            'Oui',
        colorVal: {
          black: 'Noir', blue: 'Bleu', brown: 'Marron', gray: 'Gris',
          green: 'Vert', pink: 'Rose', purple: 'Violet', red: 'Rouge',
          white: 'Blanc', yellow: 'Jaune',
        },
        shapeVal: {
          ball: 'Boule', squiggle: 'Tortillon', fish: 'Poisson',
          arms: 'Bras', blob: 'Masse', upright: 'Bipède',
          legs: 'Jambes', quadruped: 'Quadrupède', wings: 'Ailé',
          tentacles: 'Tentacules', heads: 'Têtes', humanoid: 'Humanoïde',
          'bug-wings': 'Ailes insecte', armor: 'Armure',
        },
        habitatVal: {
          cave: 'Grotte', forest: 'Forêt', grassland: 'Prairie',
          mountain: 'Montagne', rare: 'Rare', 'rough-terrain': 'Terrain accidenté',
          sea: 'Mer', urban: 'Urbain', 'waters-edge': 'Bord de l\'eau',
        },
        growthVal: {
          slow: 'Lent', 'medium-slow': 'Moyen-lent', medium: 'Moyen',
          fast: 'Rapide', 'medium-fast': 'Moyen-rapide',
          'slow-then-very-fast': 'Lent puis très rapide',
          'fast-then-very-slow': 'Rapide puis très lent',
          erratic: 'Erratique', fluctuating: 'Fluctuant',
        },
      },

      gender: {
        neutral:   'Asexué',
        maleOnly:  '100% Mâle',
        femaleOnly:'100% Femelle',
        ratio:     '♂ {male}% · ♀ {female}%',
      },

      badge: {
        legendary:     'Légendaire',
        mythical:      'Fabuleux',
        baby:          'Bébé 🍼',
        hiddenAbility: 'Talent caché',
        babyEvo:       'Bébé',
        default:       '(défaut)',
      },

      section: {
        baseStats:       'Statistiques de base',
        abilities:       'Capacités',
        breeding:        'Élevage',
        pastTypes:       'Types anciens',
        pokedexNumbers:  'Numéros Pokédex',
        varieties:       'Variantes / Formes',
        palPark:         'Parc Ami (PAL Park)',
        gameIndices:     'Indices de jeu',
        movesTitle:      'Capacités ({count} au total)',
        sprites:         'Galerie de sprites',
        evoChain:        "Chaîne d'évolution",
        pokedexDesc:     'Description Pokédex',
        cries:           'Cris (sons)',
        encountersTitle: 'Zones de rencontre ({count} lieux)',
        languagesTitle:  'Noms dans toutes les langues ({count})',
      },

      breeding: {
        eggGroups:    'Groupes Œufs',
        hatchCounter: "Compteur d'éclosion",
        cycles:       'cycles',
        steps:        'pas',
      },

      pastTypes: {
        before: 'Avant la génération {gen}',
      },

      moves: {
        level: 'Niv.',
        move:  'Capacité',
      },

      palPark: {
        scoreRate: 'Score {score} · Taux {rate}',
      },

      sprite: {
        normal:              'Normal',
        back:                'Dos',
        shiny:               'Shiny',
        shinyBack:           'Shiny dos',
        female:              'Femelle',
        femaleBack:          'Femelle dos',
        shinyFemale:         'Shiny femelle',
        officialArtwork:     'Artwork officiel',
        officialArtworkShiny:'Artwork shiny',
        home:                'HOME',
        homeShiny:           'HOME Shiny',
        showdown:            'Showdown',
        showdownShiny:       'Showdown shiny',
        dreamWorld:          'Dream World',
      },

      flavor: {
        noDesc: 'Aucune description pour cette langue/version.',
      },

      cries: {
        latest: 'Cri actuel',
        legacy: 'Cri legacy',
      },

      encounters: {
        notWild: "Ce Pokémon ne se trouve pas à l'état sauvage.",
      },

      evo: {
        level:         'Niv. {level}',
        useItem:       'Utiliser : {item}',
        holdItem:      'Tenir : {item}',
        trade:         'Échange',
        happiness:     'Bonheur ≥ {value}',
        beauty:        'Beauté ≥ {value}',
        affection:     'Affection ≥ {value}',
        knownMove:     'Connaît : {move}',
        knownMoveType: 'Type connu : {type}',
        location:      'Lieu : {location}',
        timeOfDay:     'Moment : {time}',
        femaleOnly:    'Femelle uniquement',
        maleOnly:      'Mâle uniquement',
        rain:          'Sous la pluie',
        upsideDown:    'DS retournée',
        partySpecies:  'Avec : {species}',
        partyType:     'Type en équipe : {type}',
        tradeSpecies:  'Échange avec : {species}',
      },
    },

    classic: {
      won: '{name} — trouvé en {count} essai{s} !',
      col: {
        name:           'Pokémon',
        types:          'Types',
        generation:     'Génération',
        color:          'Couleur',
        shape:          'Forme',
        evolutionStage: 'Stade',
        height:         'Taille',
        weight:         'Poids',
      },
      color: {
        black: 'Noir', blue: 'Bleu', brown: 'Marron', gray: 'Gris',
        green: 'Vert', pink: 'Rose', purple: 'Violet', red: 'Rouge',
        white: 'Blanc', yellow: 'Jaune',
      },
      shape: {
        ball: 'Boule', squiggle: 'Tortillon', fish: 'Poisson',
        arms: 'Bras', blob: 'Masse', upright: 'Bipède',
        legs: 'Jambes', quadruped: 'Quadrupède', wings: 'Ailes',
        tentacles: 'Tentacules', heads: 'Têtes', humanoid: 'Humanoïde',
        'bug-wings': 'Ailes insecte', armor: 'Armure',
      },
      hint: {
        title:          'Indices débloqués',
        firstLetter:    'Première lettre',
        type:           'Type principal',
        generation:     'Génération',
        evolutionStage: 'Stade d\'évolution',
        cry:            'Cri du Pokémon',
        silhouette:     'Silhouette',
        next:           'Prochain indice dans {remaining} essai{s}',
      },
    },

    authModal: {
      // Titres
      loginTitle: 'Connexion',     // en: 'Login' | de: 'Anmelden' ...
      registerTitle: 'Inscription',
      forgotTitle: 'Mot de passe oublié ?',

      // Labels
      usernameLabel: 'Pseudo',
      emailLabel: 'Email',
      passwordLabel: 'Mot de passe',

      // Placeholders
      usernamePlaceholder: 'Choisis ton nom de dresseur',
      emailPlaceholder: 'pokemon@master.com',
      passwordPlaceholder: 'Ton mot de passe',

      // Boutons
      submitLogin: 'Attraper les tous !',
      submitRegister: 'Créer mon équipe',
      submitting: 'Capture en cours...',
      sendReset: 'Envoyer le lien de réinitialisation',
      sending: 'Envoi en cours...',
      backToLogin: '← Retour à la connexion',
      forgotPassword: 'Mot de passe oublié ?',
      createAccount: 'Créer un compte',
      loginInstead: 'Se connecter',

      // Toggle texts
      noAccount: "Pas encore d'équipe ?",
      hasAccount: 'Déjà un dresseur ?',

      // Erreurs
      emailRequired: 'L\'email est requis',
      emailInvalid: 'Email invalide',
      passwordRequired: 'Le mot de passe est requis',
      passwordMin: 'Minimum 6 caractères',
      usernameMin: 'Pseudo minimum 3 caractères',
      emailNotFound: 'Email introuvable',
      requestTimeout: 'Requête trop longue (10s)',
      networkError: 'Erreur réseau. Vérifiez votre connexion.',
      generalError: 'Erreur lors de la requête',

      // Succès
      resetSent: 'Lien de réinitialisation envoyé ! Vérifie ta boîte mail.',

      // ARIA
      showPassword: 'Afficher le mot de passe',
      hidePassword: 'Masquer le mot de passe',
    },

    resetPassword: {
      title: 'Réinitialiser le mot de passe',
      emailLabel: 'Email',
      emailPlaceholder: 'votre@email.com',
      newPasswordLabel: 'Nouveau mot de passe',
      newPasswordPlaceholder: 'Nouveau mot de passe (min 6)',
      confirmLabel: 'Confirmer',
      confirmPlaceholder: 'Confirmez le mot de passe',
      submitButton: 'Réinitialiser',
      submitting: 'Réinitialisation...',
      closeButton: 'Fermer',
      passwordMismatch: 'Les mots de passe ne correspondent pas',
      passwordTooShort: 'Mot de passe trop court (min 6 caractères)',
      successMessage: 'Mot de passe réinitialisé ! Redirection...',
      resetError: 'Erreur lors de la réinitialisation',
    },
  },

  en: {
    home:              'Home',
    pokedex:           '📋 Pokédex',
    miniGames:         '🎮 Mini-Games',
    tactics:           '⚔️ Tactics',

    welcome:           'Welcome, Trainer',
    subtitle:          'Catch, battle and explore the Pokémon world.\nYour adventure starts here.',
    launchSafari:      'Launch PokeWordle',
    openPokedex:       'Open Pokédex',

    availablePokemons: 'Available Pokémon',
    legendaries:       'Legendaries',
    generations:       'Generations',
    miniGamesLabel:    'Mini-Games',

    pokemonOfDay:      'Pokémon of the Day',
    dailyRenewal:      'Daily renewal',

    types: {
      fire: 'Fire', water: 'Water', grass: 'Grass', electric: 'Electric',
      psychic: 'Psychic', ice: 'Ice', dragon: 'Dragon', dark: 'Dark',
      fairy: 'Fairy', normal: 'Normal', fighting: 'Fighting', flying: 'Flying',
      poison: 'Poison', ground: 'Ground', rock: 'Rock', bug: 'Bug',
      ghost: 'Ghost', steel: 'Steel'
    },

    ficheTitle:        'Strategic Sheet for',
    recommendedRole:   'Recommended role',
    natureBuild:       'Nature',
    evsBuild:          'EVs',
    itemBuild:         'Item',
    weaknesses:        'Weaknesses',
    resistances:       'Resistances',
    immunities:        'Immunities',

    tierUberDesc:      'Dominant legendary',
    tierOUDesc:        'Highly competitive',
    tierUUDesc:        'Solid competitive',
    tierRUDesc:        'Regional usage',
    tierNUDesc:        'Accessible to all',

    roleAttack:        'Physical Attacker',
    roleSpAtk:         'Special Attacker',
    roleDefense:       'Physical Wall',
    roleSpDef:         'Special Wall',
    roleSpeed:         'Speed Sweeper',
    roleHp:            'General Tank',

    natureJovial:      'Adamant (+Atk)',
    natureModeste:     'Modest (+Sp.Atk)',
    natureImpudent:    'Bold (+Def)',
    natureDoux:        'Calm (+Sp.Def)',
    natureTimide:      'Timid (+Spd)',
    naturePrudent:     'Careful (+Sp.Def)',

    itemCeinture:      'Choice Band',
    itemLunette:       'Choice Specs',
    itemRestes:        'Leftovers',
    itemFoulard:       'Choice Scarf',

    statHp:            'HP',
    statAtk:           'ATK',
    statDef:           'DEF',
    statSpAtk:         'SP.ATK',
    statSpDef:         'SP.DEF',
    statSpeed:         'SPD',

    navHome: 'Home',
    navPokedex: 'Pokédex',
    navGames: 'Mini Games',
    navLegendaries: 'Legendaries',

    featuresTitle: 'Choose your Adventure',
    featuresSubtitle: 'Several ways to explore the Pokémon world',
    featureSafari: 'Safari Zone',
    featureSafariDesc: 'Catch wild Pokémon, build your team and battle legendary Bosses.',
    featurePokedex: 'Pokédex',
    featurePokedexDesc: 'Explore the complete database of 1000+ Pokémon with stats, types and evolutions.',
    featureQuiz: 'Pokémon Quiz',
    featureQuizDesc: 'Test your knowledge! Silhouettes, cries, types… Can you recognize them all?',
    featureTeamBuilder: 'Team Builder',
    featureTeamBuilderDesc: 'Build and optimize your competitive team with type analysis and synergies.',
    featureSafariBadge: 'IDLE RPG',
    featurePokedexBadge: 'ENCYCLOPEDIA',
    featureComingSoon: 'SOON',
    featurePlay: 'Discover',
    featureSafariStats: 'Capture & Combat',
    featurePokedexStats: '1000+ Pokémon',
    featureQuizStats: 'Riddles & Score',
    featureTeamStats: 'Strategy',

    pokedexPreviewTitle: 'Pokédex Preview',
    pokedexPreviewSubtitle: '{count} Pokémon await you',
    pokedexPreviewButton: 'See all {count} Pokémon',

    historyTitle:   'History',
    continueButton: 'Play again',
    defeatTitle:    'Defeat',
    pointsGained:   'Points +{points}',
    victoryTitle:   'Victory',

    pokedexKeys: {
      selectGeneration: 'Select one generation',
      allGenerations: 'All',
      searchPokemon: 'Search a Pokemon...',
      noPokemonFound: 'No Pokemon found',
      filterType: 'Type',
      filterColor: 'Color',
      sortBy: 'Sort by',
      sortNumber: 'Number (ID)',
      sortNameAsc: 'Name (A-Z)',
      sortNameDesc: 'Name (Z-A)',
      sortTotalStatsDesc: 'Total stats (↓)',
      sortTotalStatsAsc: 'Total stats (↑)',
      sortHpDesc: 'HP (↓)',
      sortHpAsc: 'HP (↑)',
      sortAttackDesc: 'Attack (↓)',
      sortAttackAsc: 'Attack (↑)',
      sortDefenseDesc: 'Defense (↓)',
      sortDefenseAsc: 'Defense (↑)',
      sortSpAtkDesc: 'Sp. Atk (↓)',
      sortSpAtkAsc: 'Sp. Atk (↑)',
      sortSpDefDesc: 'Sp. Def (↓)',
      sortSpDefAsc: 'Sp. Def (↑)',
      sortSpeedDesc: 'Speed (↓)',
      sortSpeedAsc: 'Speed (↑)',
      normal: 'Normal', fire: 'Fire', water: 'Water', grass: 'Grass',
      electric: 'Electric', ice: 'Ice', fighting: 'Fighting', poison: 'Poison',
      ground: 'Ground', flying: 'Flying', psychic: 'Psychic', bug: 'Bug',
      rock: 'Rock', ghost: 'Ghost', dragon: 'Dragon', dark: 'Dark',
      steel: 'Steel', fairy: 'Fairy',
      black: 'Black', blue: 'Blue', brown: 'Brown', gray: 'Gray',
      green: 'Green', pink: 'Pink', purple: 'Purple', red: 'Red',
      white: 'White', yellow: 'Yellow'
    },

    gameModes: 'Game Modes',
    gameSubtitle: 'Test your Pokémon knowledge!',
    
    // shadow
    shadow: 'Silhouette',
    shadowDesc: 'Guess the Pokémon from its blurred silhouette',
    
    // description  
    description: 'Description',
    
    // type
    type: 'Types',
    typeDesc: 'Find all types by elimination',
    
    // hangman
    hangman: 'Hangman',
    hangmanDesc: 'Classic hangman with Pokémon names',
    
    // memory
    memory: 'Memory',
    memoryDesc: 'Match Pokémon pairs',
    
    // higher-lower
    higherLower: 'Higher or Lower',
    higherLowerDesc: 'Guess which Pokémon is heavier',
    
    // type-challenge
    typeChallenge: 'Type Challenge',
    typeChallengeDesc: 'Identify types under time pressure',
    
    // safarizone
    safariZone: 'Safari Zone',
    safariZoneDesc: 'Idle clicker & team builder',
    
    // Shared
    descriptionDesc: 'No description available',
    Quitter: 'Quit',
    Score: 'Score',
    Essais: 'Attempts',
    Valider: 'Validate',
    Continuer: 'Continue',
    Rejouer: 'Play Again',

    quitButton: 'Quit',
    scoreLabel: 'Score',
    attemptsLabel: 'Attempts',
    higherLowerTitle: '+ or - ?',
    heavierButton: 'Heavier',
    lighterButton: 'Lighter',
    vs: 'VS',
    retryButton: 'Retry',
    memoryTitle: 'Pokémon Memory',
    pairsLabel: 'Pairs',
    shadowTitle: 'Shadow',
    typeGameTitle: 'Find the Types',
    toFind: 'to find',
    validateButton: 'Validate',
    loading: 'Loading...',
    searchPokemon: 'Pokémon name...',
    arcadeRetry: 'Retry',
    timeUpMessage: 'Time’s up! Your score: {score}',
    typeQuestionPrefix: 'What type is ',
    weightUnit: 'kg',

    fp: {
      loading: 'Loading...',
      error:   'Unable to load data.',

      tab: {
        stats:      'Stats',
        moves:      'Moves',
        sprites:    'Sprites',
        evolution:  'Evolution',
        pokedex:    'Pokédex',
        encounters: 'Encounters',
        languages:  'Languages',
      },

      stat: {
        hp:               'HP',
        attack:           'Attack',
        defense:          'Defense',
        'special-attack': 'Sp. Atk',
        'special-defense':'Sp. Def',
        speed:            'Speed',
        total:            'Total',
      },

      qi: {
        height:         'Height',
        weight:         'Weight',
        baseExp:        'Base Exp.',
        captureRate:    'Capture Rate',
        baseHappiness:  'Base Happiness',
        growthRate:     'Growth Rate',
        hatchSteps:     'Hatch Steps',
        hatchStepsValue:'{steps} steps',
        gender:         'Gender',
        color:          'Color',
        shape:          'Shape',
        habitat:        'Habitat',
        generation:     'Generation',
        evolvesFrom:    'Evolves from',
        genderDiff:     'Gender differences',
        switchableForms:'Switchable forms',
        yes:            'Yes',
        colorVal: {
          black: 'Black', blue: 'Blue', brown: 'Brown', gray: 'Gray',
          green: 'Green', pink: 'Pink', purple: 'Purple', red: 'Red',
          white: 'White', yellow: 'Yellow',
        },
        shapeVal: {
          ball: 'Ball', squiggle: 'Squiggle', fish: 'Fish',
          arms: 'Arms', blob: 'Blob', upright: 'Upright',
          legs: 'Legs', quadruped: 'Quadruped', wings: 'Winged',
          tentacles: 'Tentacles', heads: 'Heads', humanoid: 'Humanoid',
          'bug-wings': 'Bug-wings', armor: 'Armor',
        },
        habitatVal: {
          cave: 'Cave', forest: 'Forest', grassland: 'Grassland',
          mountain: 'Mountain', rare: 'Rare', 'rough-terrain': 'Rough terrain',
          sea: 'Sea', urban: 'Urban', 'waters-edge': 'Water\'s edge',
        },
        growthVal: {
          slow: 'Slow', 'medium-slow': 'Medium slow', medium: 'Medium',
          fast: 'Fast', 'medium-fast': 'Medium fast',
          'slow-then-very-fast': 'Slow then very fast',
          'fast-then-very-slow': 'Fast then very slow',
          erratic: 'Erratic', fluctuating: 'Fluctuating',
        },
      },

      gender: {
        neutral:   'Genderless',
        maleOnly:  '100% Male',
        femaleOnly:'100% Female',
        ratio:     '♂ {male}% · ♀ {female}%',
      },

      badge: {
        legendary:     'Legendary ✨',
        mythical:      'Mythical 🌟',
        baby:          'Baby 🍼',
        hiddenAbility: 'Hidden Ability',
        babyEvo:       'Baby',
        default:       '(default)',
      },

      section: {
        baseStats:       'Base Stats',
        abilities:       'Abilities',
        breeding:        'Breeding',
        pastTypes:       'Past Types',
        pokedexNumbers:  'Pokédex Numbers',
        varieties:       'Varieties / Forms',
        palPark:         'PAL Park',
        gameIndices:     'Game Indices',
        movesTitle:      'Moves ({count} total)',
        sprites:         'Sprite Gallery',
        evoChain:        'Evolution Chain',
        pokedexDesc:     'Pokédex Entry',
        cries:           'Cries (sounds)',
        encountersTitle: 'Encounter Locations ({count})',
        languagesTitle:  'Names in all languages ({count})',
      },

      breeding: {
        eggGroups:    'Egg Groups',
        hatchCounter: 'Hatch Counter',
        cycles:       'cycles',
        steps:        'steps',
      },

      pastTypes: {
        before: 'Before generation {gen}',
      },

      moves: {
        level: 'Lv.',
        move:  'Move',
      },

      palPark: {
        scoreRate: 'Score {score} · Rate {rate}',
      },

      sprite: {
        normal:              'Normal',
        back:                'Back',
        shiny:               'Shiny',
        shinyBack:           'Shiny back',
        female:              'Female',
        femaleBack:          'Female back',
        shinyFemale:         'Shiny female',
        officialArtwork:     'Official Artwork',
        officialArtworkShiny:'Shiny Artwork',
        home:                'HOME',
        homeShiny:           'HOME Shiny',
        showdown:            'Showdown',
        showdownShiny:       'Showdown Shiny',
        dreamWorld:          'Dream World',
      },

      flavor: {
        noDesc: 'No description for this language/version.',
      },

      cries: {
        latest: 'Current cry',
        legacy: 'Legacy cry',
      },

      encounters: {
        notWild: 'This Pokémon is not found in the wild.',
      },

      evo: {
        level:         'Lv. {level}',
        useItem:       'Use: {item}',
        holdItem:      'Hold: {item}',
        trade:         'Trade',
        happiness:     'Happiness ≥ {value}',
        beauty:        'Beauty ≥ {value}',
        affection:     'Affection ≥ {value}',
        knownMove:     'Knows: {move}',
        knownMoveType: 'Known type: {type}',
        location:      'Location: {location}',
        timeOfDay:     'Time: {time}',
        femaleOnly:    'Female only',
        maleOnly:      'Male only',
        rain:          'While raining',
        upsideDown:    'Upside-down DS',
        partySpecies:  'With: {species}',
        partyType:     'Party type: {type}',
        tradeSpecies:  'Trade with: {species}',
      },
    },

    classicGameDesc: 'A mystery Pokémon is hiding! Guess it by typing names. Each attempt gives you clues: type, generation, color, size… The closer you are, the more cells light up!',
    classic: {
      won: '{name} — found in {count} guess{s}!',
      col: {
        name:           'Pokémon',
        types:          'Types',
        generation:     'Generation',
        color:          'Color',
        shape:          'Shape',
        evolutionStage: 'Stage',
        height:         'Height',
        weight:         'Weight',
      },
      color: {
        black: 'Black', blue: 'Blue', brown: 'Brown', gray: 'Gray',
        green: 'Green', pink: 'Pink', purple: 'Purple', red: 'Red',
        white: 'White', yellow: 'Yellow',
      },
      shape: {
        ball: 'Ball', squiggle: 'Squiggle', fish: 'Fish',
        arms: 'Arms', blob: 'Blob', upright: 'Upright',
        legs: 'Legs', quadruped: 'Quadruped', wings: 'Wings',
        tentacles: 'Tentacles', heads: 'Heads', humanoid: 'Humanoid',
        'bug-wings': 'Bug-wings', armor: 'Armor',
      },
      hint: {
        title:          'Unlocked hints',
        firstLetter:    'First letter',
        type:           'Primary type',
        generation:     'Generation',
        evolutionStage: 'Evolution stage',
        cry:            'Pokémon cry',
        silhouette:     'Silhouette',
        next:           'Next hint in {remaining} guess{s}',
      },
    },

    authModal:{
      loginTitle: 'Login',
      registerTitle: 'Register',
      forgotTitle: 'Forgot Password?',
      usernameLabel: 'Username',
      emailLabel: 'Email',
      passwordLabel: 'Password',
      usernamePlaceholder: 'Choose your trainer name',
      emailPlaceholder: 'pokemon@master.com',
      passwordPlaceholder: 'Your password',
      submitLogin: 'Catch \'em all!',
      submitRegister: 'Create my team',
      submitting: 'Capturing...',
      sendReset: 'Send reset link',
      sending: 'Sending...',
      backToLogin: '← Back to login',
      forgotPassword: 'Forgot password?',
      createAccount: 'Create account',
      loginInstead: 'Log in',
      noAccount: 'No team yet?',
      hasAccount: 'Already a trainer?',
      emailRequired: 'Email is required',
      emailInvalid: 'Invalid email',
      passwordRequired: 'Password is required',
      passwordMin: 'Minimum 6 characters',
      usernameMin: 'Username minimum 3 characters',
      emailNotFound: 'Email not found',
      requestTimeout: 'Request too long (10s)',
      networkError: 'Network error. Check your connection.',
      generalError: 'Request error',
      resetSent: 'Reset link sent! Check your email.',
      showPassword: 'Show password',
      hidePassword: 'Hide password',
    },
    resetPassword: {
      title: 'Reset Password',
      emailLabel: 'Email',
      emailPlaceholder: 'your@email.com',
      newPasswordLabel: 'New Password',
      newPasswordPlaceholder: 'New password (min 6)',
      confirmLabel: 'Confirm',
      confirmPlaceholder: 'Confirm password',
      submitButton: 'Reset',
      submitting: 'Resetting...',
      closeButton: 'Close',
      passwordMismatch: 'Passwords do not match',
      passwordTooShort: 'Password too short (min 6 characters)',
      successMessage: 'Password reset! Redirecting...',
      resetError: 'Reset error',
    },
  },

  de: {
    home:              'Startseite',
    pokedex:           '📋 Pokédex',
    miniGames:         '🎮 Mini-Spiele',
    tactics:           '⚔️ Taktik',

    welcome:           'Willkommen, Trainer',
    subtitle:          'Fange, kämpfe und erkunde die Pokémon-Welt.\nDein Abenteuer beginnt hier.',
    launchSafari:      'PokeWordle starten',
    openPokedex:       'Pokédex öffnen',

    availablePokemons: 'Verfügbare Pokémon',
    legendaries:       'Legendäre',
    generations:       'Generationen',
    miniGamesLabel:    'Mini-Spiele',

    pokemonOfDay:      'Pokémon des Tages',
    dailyRenewal:      'Tägliche Erneuerung',

    types: {
      fire: 'Feuer', water: 'Wasser', grass: 'Pflanze', electric: 'Elektro',
      psychic: 'Psycho', ice: 'Eis', dragon: 'Drache', dark: 'Unlicht',
      fairy: 'Fee', normal: 'Normal', fighting: 'Kampf', flying: 'Flug',
      poison: 'Gift', ground: 'Boden', rock: 'Gestein', bug: 'Käfer',
      ghost: 'Geist', steel: 'Stahl'
    },

    ficheTitle:        'Strategiebogen für',
    recommendedRole:   'Empfohlene Rolle',
    natureBuild:       'Natur',
    evsBuild:          'EVs',
    itemBuild:         'Item',
    weaknesses:        'Schwächen',
    resistances:       'Resistenzen',
    immunities:        'Immunitäten',

    tierUberDesc:      'Dominante Legende',
    tierOUDesc:        'Sehr kompetitiv',
    tierUUDesc:        'Solide kompetitiv',
    tierRUDesc:        'Regionale Nutzung',
    tierNUDesc:        'Für alle zugänglich',

    roleAttack:        'Physischer Angreifer',
    roleSpAtk:         'Spezieller Angreifer',
    roleDefense:       'Physische Mauer',
    roleSpDef:         'Spezielle Mauer',
    roleSpeed:         'Geschwindigkeits-Sweeper',
    roleHp:            'Allgemeiner Tank',

    natureJovial:      'Mutig (+Atk)',
    natureModeste:     'Still (+SP.ATK)',
    natureImpudent:    'Kühn (+Def)',
    natureDoux:        'Sanft (+SP.DEF)',
    natureTimide:      'Scheu (+Spd)',
    naturePrudent:     'Sorgfältig (+SP.DEF)',

    itemCeinture:      'Wahl-Band',
    itemLunette:       'Wahl-Brille',
    itemRestes:        'Überreste',
    itemFoulard:       'Wahl-Schal',

    statHp:            'KP',
    statAtk:           'ATK',
    statDef:           'VER',
    statSpAtk:         'SP.ATK',
    statSpDef:         'SP.VER',
    statSpeed:         'INIT',

    navHome: 'Startseite',
    navPokedex: 'Pokédex',
    navGames: 'Minispiele',
    navLegendaries: 'Legendäre',

    featuresTitle: 'Wähle dein Abenteuer',
    featuresSubtitle: 'Mehrere Wege, die Pokémon-Welt zu erkunden',
    featureSafari: 'Safari-Zone',
    featureSafariDesc: 'Fange wilde Pokémon, baue dein Team und kämpfe gegen legendäre Bosse.',
    featurePokedex: 'Pokédex',
    featurePokedexDesc: 'Erkunde die vollständige Datenbank mit 1000+ Pokémon, Stats, Typen und Evolutionen.',
    featureQuiz: 'Pokémon-Quiz',
    featureQuizDesc: 'Teste dein Wissen! Silhouetten, Schreie, Typen… Kannst du sie alle erkennen?',
    featureTeamBuilder: 'Team-Builder',
    featureTeamBuilderDesc: 'Baue und optimiere dein kompetitives Team mit Typenanalyse und Synergien.',
    featureSafariBadge: 'IDLE RPG',
    featurePokedexBadge: 'ENCYCLOPÄDIE',
    featureComingSoon: 'BALD',
    featurePlay: 'Entdecken',
    featureSafariStats: 'Fangen & Kämpfen',
    featurePokedexStats: '1000+ Pokémon',
    featureQuizStats: 'Rätsel & Punkte',
    featureTeamStats: 'Strategie',

    pokedexPreviewTitle: 'Pokédex-Vorschau',
    pokedexPreviewSubtitle: '{count} Pokémon warten auf dich',
    pokedexPreviewButton: '{count} Pokémon ansehen',

    historyTitle:   'Verlauf',
    continueButton: 'Nochmal spielen',
    defeatTitle:    'Niederlage',
    pointsGained: 'Punkte +{points}',
    victoryTitle:   'Sieg',

    pokedexKeys: {
      selectGeneration: 'Wähle eine Generation',
      allGenerations: 'Alle',
      searchPokemon: 'Pokémon suchen...',
      noPokemonFound: 'Kein Pokémon gefunden',
      filterType: 'Typ',
      filterColor: 'Farbe',
      sortBy: 'Sortieren nach',
      sortNumber: 'Nummer (ID)',
      sortNameAsc: 'Name (A-Z)',
      sortNameDesc: 'Name (Z-A)',
      sortTotalStatsDesc: 'Gesamtstats (↓)',
      sortTotalStatsAsc: 'Gesamtstats (↑)',
      sortHpDesc: 'KP (↓)',
      sortHpAsc: 'KP (↑)',
      sortAttackDesc: 'Attacke (↓)',
      sortAttackAsc: 'Attacke (↑)',
      sortDefenseDesc: 'Verteidigung (↓)',
      sortDefenseAsc: 'Verteidigung (↑)',
      sortSpAtkDesc: 'Sp.Atk (↓)',
      sortSpAtkAsc: 'Sp.Atk (↑)',
      sortSpDefDesc: 'Sp.Ver (↓)',
      sortSpDefAsc: 'Sp.Ver (↑)',
      sortSpeedDesc: 'Initiative (↓)',
      sortSpeedAsc: 'Initiative (↑)',
      normal: 'Normal', fire: 'Feuer', water: 'Wasser', grass: 'Pflanze',
      electric: 'Elektro', ice: 'Eis', fighting: 'Kampf', poison: 'Gift',
      ground: 'Boden', flying: 'Flug', psychic: 'Psycho', bug: 'Käfer',
      rock: 'Gestein', ghost: 'Geist', dragon: 'Drache', dark: 'Unlicht',
      steel: 'Stahl', fairy: 'Fee',
      black: 'Schwarz', blue: 'Blau', brown: 'Braun', gray: 'Grau',
      green: 'Grün', pink: 'Rosa', purple: 'Lila', red: 'Rot',
      white: 'Weiß', yellow: 'Gelb'
    },

    gameModes: 'Spielmodi',
    gameSubtitle: 'Teste dein Pokémon-Wissen!',
    
    shadow: 'Silhouette',
    shadowDesc: 'Errate das Pokémon aus dem verschwommenen Schatten',
    
    description: 'Beschreibung',
    
    type: 'Typen',
    typeDesc: 'Finde alle Typen durch Ausschluss',
    
    hangman: 'Hangman',
    hangmanDesc: 'Klassisches Hangman mit Pokémon-Namen',
    
    memory: 'Memory',
    memoryDesc: 'Paare Pokémon zusammen',
    
    higherLower: 'Höher oder Niedriger',
    higherLowerDesc: 'Rate welches Pokémon schwerer ist',
    
    typeChallenge: 'Typen-Herausforderung',
    typeChallengeDesc: 'Identifiziere Typen unter Zeitdruck',
    
    safariZone: 'Safari-Zone',
    safariZoneDesc: 'Idle-Clicker & Team-Builder',
    
    descriptionDesc: 'Beschreibung nicht verfügbar',
    Quitter: 'Beenden',
    Score: 'Punkte',
    Essais: 'Versuche',
    Valider: 'Bestätigen',
    Continuer: 'Weiter',
    Rejouer: 'Nochmal',

    quitButton: 'Beenden',
    scoreLabel: 'Punkte',
    attemptsLabel: 'Versuche',
    higherLowerTitle: '+ oder - ?',
    heavierButton: 'Schwerer',
    lighterButton: 'Leichter',
    vs: 'VS',
    retryButton: 'Nochmal',
    memoryTitle: 'Pokémon-Gedächtnis',
    pairsLabel: 'Paare',
    shadowTitle: 'Schatten',
    typeGameTitle: 'Finde die Typen',
    toFind: 'zu finden',
    validateButton: 'Bestätigen',
    loading: 'Laden...',
    searchPokemon: 'Pokémon-Name...',
    arcadeRetry: 'Erneut versuchen',
    timeUpMessage: 'Zeit um! Dein Punktestand: {score}',
    typeQuestionPrefix: 'Welches Typ ist ',
    weightUnit: 'kg',

    fp: {
      loading: 'Lade vollständige Daten...',
      error:   'Daten konnten nicht geladen werden.',

      tab: {
        stats:      'Stats',
        moves:      'Attacken',
        sprites:    'Sprites',
        evolution:  'Entwicklung',
        pokedex:    'Pokédex',
        encounters: 'Fundorte',
        languages:  'Sprachen',
      },

      stat: {
        hp:               'KP',
        attack:           'Angriff',
        defense:          'Verteidigung',
        'special-attack': 'Sp.-Angriff',
        'special-defense':'Sp.-Verteidigung',
        speed:            'Initiative',
        total:            'Gesamt',
      },

      qi: {
        height:         'Größe',
        weight:         'Gewicht',
        baseExp:        'Basis-EP',
        captureRate:    'Fangrate',
        baseHappiness:  'Basis-Freundschaft',
        growthRate:     'Wachstumsrate',
        hatchSteps:     'Brutschritte',
        hatchStepsValue:'{steps} Schritte',
        gender:         'Geschlecht',
        color:          'Farbe',
        shape:          'Form',
        habitat:        'Habitat',
        generation:     'Generation',
        evolvesFrom:    'Entwickelt aus',
        genderDiff:     'Geschlechtsunterschiede',
        switchableForms:'Wechselbare Formen',
        yes:            'Ja',
        colorVal: {
          black: 'Schwarz', blue: 'Blau', brown: 'Braun', gray: 'Grau',
          green: 'Grün', pink: 'Rosa', purple: 'Lila', red: 'Rot',
          white: 'Weiß', yellow: 'Gelb',
        },
        shapeVal: {
          ball: 'Kugel', squiggle: 'Kurve', fish: 'Fisch',
          arms: 'Arme', blob: 'Klumpen', upright: 'Aufrecht',
          legs: 'Beine', quadruped: 'Vierfüßer', wings: 'Geflügelt',
          tentacles: 'Tentakel', heads: 'Köpfe', humanoid: 'Humanoid',
          'bug-wings': 'Insektenflügel', armor: 'Rüstung',
        },
        habitatVal: {
          cave: 'Höhle', forest: 'Wald', grassland: 'Grasland',
          mountain: 'Berg', rare: 'Selten', 'rough-terrain': 'Raues Gelände',
          sea: 'Meer', urban: 'Stadtgebiet', 'waters-edge': 'Gewässerrand',
        },
        growthVal: {
          slow: 'Langsam', 'medium-slow': 'Mittel-langsam', medium: 'Mittel',
          fast: 'Schnell', 'medium-fast': 'Mittel-schnell',
          'slow-then-very-fast': 'Langsam dann sehr schnell',
          'fast-then-very-slow': 'Schnell dann sehr langsam',
          erratic: 'Unregelmäßig', fluctuating: 'Schwankend',
        },
      },

      gender: {
        neutral:   'Geschlechtslos',
        maleOnly:  '100% Männlich',
        femaleOnly:'100% Weiblich',
        ratio:     '♂ {male}% · ♀ {female}%',
      },

      badge: {
        legendary:     'Legendär ✨',
        mythical:      'Mysteriös 🌟',
        baby:          'Baby 🍼',
        hiddenAbility: 'Versteckte Fähigkeit',
        babyEvo:       'Baby',
        default:       '(Standard)',
      },

      section: {
        baseStats:       'Basiswerte',
        abilities:       'Fähigkeiten',
        breeding:        'Zucht',
        pastTypes:       'Frühere Typen',
        pokedexNumbers:  'Pokédex-Nummern',
        varieties:       'Varianten / Formen',
        palPark:         'Pal Park',
        gameIndices:     'Spielindizes',
        movesTitle:      'Attacken ({count} insgesamt)',
        sprites:         'Sprite-Galerie',
        evoChain:        'Entwicklungsreihe',
        pokedexDesc:     'Pokédex-Eintrag',
        cries:           'Schreie (Töne)',
        encountersTitle: 'Fundorte ({count})',
        languagesTitle:  'Namen in allen Sprachen ({count})',
      },

      breeding: {
        eggGroups:    'Ei-Gruppen',
        hatchCounter: 'Brutzyklen',
        cycles:       'Zyklen',
        steps:        'Schritte',
      },

      pastTypes: { before: 'Vor Generation {gen}' },
      moves: { level: 'Lv.', move: 'Attacke' },
      palPark: { scoreRate: 'Punkte {score} · Rate {rate}' },

      sprite: {
        normal:              'Normal',
        back:                'Rücken',
        shiny:               'Shiny',
        shinyBack:           'Shiny Rücken',
        female:              'Weiblich',
        femaleBack:          'Weiblich Rücken',
        shinyFemale:         'Shiny Weiblich',
        officialArtwork:     'Offizielles Artwork',
        officialArtworkShiny:'Shiny Artwork',
        home:                'HOME',
        homeShiny:           'HOME Shiny',
        showdown:            'Showdown',
        showdownShiny:       'Showdown Shiny',
        dreamWorld:          'Traumwelt',
      },

      flavor: { noDesc: 'Keine Beschreibung für diese Sprache/Version.' },
      cries: { latest: 'Aktueller Schrei', legacy: 'Alter Schrei' },
      encounters: { notWild: 'Dieses Pokémon kommt nicht in der Wildnis vor.' },

      evo: {
        level:         'Lv. {level}',
        useItem:       'Item benutzen: {item}',
        holdItem:      'Item halten: {item}',
        trade:         'Tausch',
        happiness:     'Freundschaft ≥ {value}',
        beauty:        'Schönheit ≥ {value}',
        affection:     'Zuneigung ≥ {value}',
        knownMove:     'Kennt: {move}',
        knownMoveType: 'Bekannter Typ: {type}',
        location:      'Ort: {location}',
        timeOfDay:     'Tageszeit: {time}',
        femaleOnly:    'Nur weiblich',
        maleOnly:      'Nur männlich',
        rain:          'Bei Regen',
        upsideDown:    'DS umgedreht',
        partySpecies:  'Mit: {species}',
        partyType:     'Teamtyp: {type}',
        tradeSpecies:  'Tausch mit: {species}',
      },
    },
    classicGameDesc: 'Ein geheimes Pokémon versteckt sich! Errate es, indem du Namen eingibst. Jeder Versuch gibt dir Hinweise: Typ, Generation, Farbe, Größe… Je näher du bist, desto mehr Felder leuchten auf!',
    classic: {
      won: '{name} — in {count} Versuch{s} gefunden!',
      col: {
        name:           'Pokémon',
        types:          'Typen',
        generation:     'Generation',
        color:          'Farbe',
        shape:          'Form',
        evolutionStage: 'Stufe',
        height:         'Größe',
        weight:         'Gewicht',
      },
      color: {
        black: 'Schwarz', blue: 'Blau', brown: 'Braun', gray: 'Grau',
        green: 'Grün', pink: 'Rosa', purple: 'Lila', red: 'Rot',
        white: 'Weiß', yellow: 'Gelb',
      },
      shape: {
        ball: 'Kugel', squiggle: 'Kurve', fish: 'Fisch',
        arms: 'Arme', blob: 'Klumpen', upright: 'Aufrecht',
        legs: 'Beine', quadruped: 'Vierfüßer', wings: 'Flügel',
        tentacles: 'Tentakel', heads: 'Köpfe', humanoid: 'Humanoid',
        'bug-wings': 'Insektenflügel', armor: 'Rüstung',
      },
      hint: {
        title:          'Freigeschaltete Hinweise',
        firstLetter:    'Erster Buchstabe',
        type:           'Haupttyp',
        generation:     'Generation',
        evolutionStage: 'Entwicklungsstufe',
        cry:            'Pokémon-Schrei',
        silhouette:     'Silhouette',
        next:           'Nächster Hinweis in {remaining} Versuch{s}',
      },
    },

    authModal:{
      loginTitle: 'Anmelden',
      registerTitle: 'Registrieren',
      forgotTitle: 'Passwort vergessen?',
      usernameLabel: 'Benutzername',
      emailLabel: 'E-Mail',
      passwordLabel: 'Passwort',
      usernamePlaceholder: 'Wähle deinen Trainer-Namen',
      emailPlaceholder: 'pokemon@master.com',
      passwordPlaceholder: 'Dein Passwort',
      submitLogin: 'Alle fangen!',
      submitRegister: 'Mein Team erstellen',
      submitting: 'Fängt...',
      sendReset: 'Reset-Link senden',
      sending: 'Sendet...',
      backToLogin: '← Zur Anmeldung',
      forgotPassword: 'Passwort vergessen?',
      createAccount: 'Konto erstellen',
      loginInstead: 'Anmelden',
      noAccount: 'Noch kein Team?',
      hasAccount: 'Bereits Trainer?',
      emailRequired: 'E-Mail erforderlich',
      emailInvalid: 'Ungültige E-Mail',
      passwordRequired: 'Passwort erforderlich',
      passwordMin: 'Mindestens 6 Zeichen',
      usernameMin: 'Benutzername mind. 3 Zeichen',
      emailNotFound: 'E-Mail nicht gefunden',
      requestTimeout: 'Anfrage zu lang (10s)',
      networkError: 'Netzwerkfehler. Verbindung prüfen.',
      generalError: 'Anfragefehler',
      resetSent: 'Reset-Link gesendet! Überprüfe deine E-Mails.',
      showPassword: 'Passwort anzeigen',
      hidePassword: 'Passwort verstecken',
    },
    resetPassword: {
      title: 'Passwort zurücksetzen',
      emailLabel: 'E-Mail',
      emailPlaceholder: 'deine@email.com',
      newPasswordLabel: 'Neues Passwort',
      newPasswordPlaceholder: 'Neues Passwort (min 6)',
      confirmLabel: 'Bestätigen',
      confirmPlaceholder: 'Passwort bestätigen',
      submitButton: 'Zurücksetzen',
      submitting: 'Setzt zurück...',
      closeButton: 'Schließen',
      passwordMismatch: 'Passwörter stimmen nicht überein',
      passwordTooShort: 'Passwort zu kurz (min 6 Zeichen)',
      successMessage: 'Passwort zurückgesetzt! Weiterleitung...',
      resetError: 'Zurücksetzen fehlgeschlagen',
    },
  },

  es: {
    home:              'Inicio',
    pokedex:           '📋 Pokédex',
    miniGames:         '🎮 Mini-Juegos',
    tactics:           '⚔️ Tácticas',

    welcome:           'Bienvenido, Entrenador',
    subtitle:          'Captura, lucha y explora el mundo Pokémon.\nTu aventura empieza aquí.',
    launchSafari:      'Lanzar PokeWordle',
    openPokedex:       'Abrir Pokédex',

    availablePokemons: 'Pokémon disponibles',
    legendaries:       'Legendarios',
    generations:       'Generaciones',
    miniGamesLabel:    'Mini-Juegos',

    pokemonOfDay:      'Pokémon del Día',
    dailyRenewal:      'Renovación diaria',

    types: {
      fire: 'Fuego', water: 'Agua', grass: 'Planta', electric: 'Eléctrico',
      psychic: 'Psíquico', ice: 'Hielo', dragon: 'Dragón', dark: 'Siniestro',
      fairy: 'Hada', normal: 'Normal', fighting: 'Lucha', flying: 'Volador',
      poison: 'Veneno', ground: 'Tierra', rock: 'Roca', bug: 'Bicho',
      ghost: 'Fantasma', steel: 'Acero'
    },

    ficheTitle:        'Ficha Estratégica de',
    recommendedRole:   'Rol recomendado',
    natureBuild:       'Naturaleza',
    evsBuild:          'EVs',
    itemBuild:         'Objeto',
    weaknesses:        'Debilidades',
    resistances:       'Resistencias',
    immunities:        'Inmunidades',

    tierUberDesc:      'Legendario dominante',
    tierOUDesc:        'Muy competitivo',
    tierUUDesc:        'Competitivo sólido',
    tierRUDesc:        'Uso regional',
    tierNUDesc:        'Accesible para todos',

    roleAttack:        'Atacante Físico',
    roleSpAtk:         'Atacante Especial',
    roleDefense:       'Muro Físico',
    roleSpDef:         'Muro Especial',
    roleSpeed:         'Sweeper Veloz',
    roleHp:            'Tank General',

    natureJovial:      'Firme (+Atk)',
    natureModeste:     'Modesto (+Atk.Esp)',
    natureImpudent:    'Audaz (+Def)',
    natureDoux:        'Sereno (+Def.Esp)',
    natureTimide:      'Tímido (+Vel)',
    naturePrudent:     'Cauto (+Def.Esp)',

    itemCeinture:      'Banda Elegida',
    itemLunette:       'Gafas Elegidas',
    itemRestes:        'Restos',
    itemFoulard:       'Pañuelo Elegido',

    statHp:            'PS',
    statAtk:           'ATQ',
    statDef:           'DEF',
    statSpAtk:         'ATQ.ESP',
    statSpDef:         'DEF.ESP',
    statSpeed:         'VEL',

    navHome: 'Inicio',
    navPokedex: 'Pokédex',
    navGames: 'Minijuegos',
    navLegendaries: 'Legendarios',

    featuresTitle: 'Elige tu Aventura',
    featuresSubtitle: 'Varias formas de explorar el mundo Pokémon',
    featureSafari: 'Zona Safari',
    featureSafariDesc: 'Captura Pokémon salvajes, construye tu equipo y enfréntate a Jefes legendarios.',
    featurePokedex: 'Pokédex',
    featurePokedexDesc: 'Explora la base de datos completa de más de 1000 Pokémon con estadísticas, tipos y evoluciones.',
    featureQuiz: 'Quiz Pokémon',
    featureQuizDesc: '¡Prueba tus conocimientos! Siluetas, gritos, tipos… ¿Podrás reconocerlos todos?',
    featureTeamBuilder: 'Creador de Equipos',
    featureTeamBuilderDesc: 'Construye y optimiza tu equipo competitivo con análisis de tipos y sinergias.',
    featureSafariBadge: 'IDLE RPG',
    featurePokedexBadge: 'ENCICLOPEDIA',
    featureComingSoon: 'PRONTO',
    featurePlay: 'Descubrir',
    featureSafariStats: 'Captura & Combate',
    featurePokedexStats: '1000+ Pokémon',
    featureQuizStats: 'Adivinanzas & Puntos',
    featureTeamStats: 'Estrategia',

    pokedexPreviewTitle: 'Vista previa Pokédex',
    pokedexPreviewSubtitle: '{count} Pokémon te esperan',
    pokedexPreviewButton: 'Ver todos los {count} Pokémon',

    historyTitle:   'Historial',
    continueButton: 'Volver a jugar',
    defeatTitle:    'Derrota',
    pointsGained:   'Puntos +{points}',
    victoryTitle:   'Victoria',

    pokedexKeys: {
      selectGeneration: 'Selecciona una generación',
      allGenerations: 'Todas',
      searchPokemon: 'Buscar un Pokémon...',
      noPokemonFound: 'No se encontró ningún Pokémon',
      filterType: 'Tipo',
      filterColor: 'Color',
      sortBy: 'Ordenar por',
      sortNumber: 'Número (ID)',
      sortNameAsc: 'Nombre (A-Z)',
      sortNameDesc: 'Nombre (Z-A)',
      sortTotalStatsDesc: 'Estadísticas totales (↓)',
      sortTotalStatsAsc: 'Estadísticas totales (↑)',
      sortHpDesc: 'PS (↓)',
      sortHpAsc: 'PS (↑)',
      sortAttackDesc: 'Ataque (↓)',
      sortAttackAsc: 'Ataque (↑)',
      sortDefenseDesc: 'Defensa (↓)',
      sortDefenseAsc: 'Defensa (↑)',
      sortSpAtkDesc: 'Atq.Esp. (↓)',
      sortSpAtkAsc: 'Atq.Esp. (↑)',
      sortSpDefDesc: 'Def.Esp. (↓)',
      sortSpDefAsc: 'Def.Esp. (↑)',
      sortSpeedDesc: 'Velocidad (↓)',
      sortSpeedAsc: 'Velocidad (↑)',
      normal: 'Normal', fire: 'Fuego', water: 'Agua', grass: 'Planta',
      electric: 'Eléctrico', ice: 'Hielo', fighting: 'Lucha', poison: 'Veneno',
      ground: 'Tierra', flying: 'Volador', psychic: 'Psíquico', bug: 'Bicho',
      rock: 'Roca', ghost: 'Fantasma', dragon: 'Dragón', dark: 'Siniestro',
      steel: 'Acero', fairy: 'Hada',
      black: 'Negro', blue: 'Azul', brown: 'Marrón', gray: 'Gris',
      green: 'Verde', pink: 'Rosa', purple: 'Púrpura', red: 'Rojo',
      white: 'Blanco', yellow: 'Amarillo'
    },

    gameModes: 'Modos de Juego',
    gameSubtitle: '¡Prueba tus conocimientos Pokémon!',
    
    shadow: 'Silueta',
    shadowDesc: 'Adivina el Pokémon por su silueta borrosa',
    
    description: 'Descripción',
    
    type: 'Tipos',
    typeDesc: 'Encuentra todos los tipos por eliminación',
    
    hangman: 'Ahorcado',
    hangmanDesc: 'Ahorcado clásico con nombres Pokémon',
    
    memory: 'Memoria',
    memoryDesc: 'Empareja Pokémon',
    
    higherLower: 'Más o Menos',
    higherLowerDesc: 'Adivina cuál Pokémon es más pesado',
    
    typeChallenge: 'Desafío de Tipos',
    typeChallengeDesc: 'Identifica tipos bajo presión temporal',
    
    safariZone: 'Zona Safari',
    safariZoneDesc: 'Clicker idle y creador de equipo',
    
    descriptionDesc: 'Descripción no disponible',
    Quitter: 'Salir',
    Score: 'Puntuación',
    Essais: 'Intentos',
    Valider: 'Validar',
    Continuer: 'Continuar',
    Rejouer: 'Volver a Jugar',

    quitButton: 'Salir',
    scoreLabel: 'Puntuación',
    attemptsLabel: 'Intentos',
    higherLowerTitle: '¿+ o - ?',
    heavierButton: 'Más pesado',
    lighterButton: 'Más ligero',
    vs: 'VS',
    retryButton: 'Reintentar',
    memoryTitle: 'Memoria Pokémon',
    pairsLabel: 'Pares',
    shadowTitle: 'Sombra',
    typeGameTitle: 'Encuentra los Tipos',
    toFind: 'por encontrar',
    validateButton: 'Validar',
    loading: 'Cargando...',
    searchPokemones: 'Nombre del Pokémon...',
    arcadeRetry: 'Volver a intentar',
    timeUpMessage: '¡Tiempo agotado! Tu puntuación: {score}',
    typeQuestionPrefix: '¿De qué tipo es ',
    weightUnit: 'kg',

    fp: {
      loading: 'Cargando datos completos...',
      error:   'No se pudieron cargar los datos.',

      tab: {
        stats:      'Stats',
        moves:      'Movimientos',
        sprites:    'Sprites',
        evolution:  'Evolución',
        pokedex:    'Pokédex',
        encounters: 'Encuentros',
        languages:  'Idiomas',
      },

      stat: {
        hp:               'PS',
        attack:           'Ataque',
        defense:          'Defensa',
        'special-attack': 'Atq. Esp.',
        'special-defense':'Def. Esp.',
        speed:            'Velocidad',
        total:            'Total',
      },

      qi: {
        height:         'Altura',
        weight:         'Peso',
        baseExp:        'Exp. base',
        captureRate:    'Tasa captura',
        baseHappiness:  'Felicidad base',
        growthRate:     'Crecimiento',
        hatchSteps:     'Pasos eclosión',
        hatchStepsValue:'{steps} pasos',
        gender:         'Género',
        color:          'Color',
        shape:          'Forma',
        habitat:        'Hábitat',
        generation:     'Generación',
        evolvesFrom:    'Evoluciona de',
        genderDiff:     'Diferencias de género',
        switchableForms:'Formas intercambiables',
        yes:            'Sí',
        colorVal: {
          black: 'Negro', blue: 'Azul', brown: 'Marrón', gray: 'Gris',
          green: 'Verde', pink: 'Rosa', purple: 'Morado', red: 'Rojo',
          white: 'Blanco', yellow: 'Amarillo',
        },
        shapeVal: {
          ball: 'Bola', squiggle: 'Curva', fish: 'Pez',
          arms: 'Brazos', blob: 'Masa', upright: 'Erguido',
          legs: 'Patas', quadruped: 'Cuadrúpedo', wings: 'Alado',
          tentacles: 'Tentáculos', heads: 'Cabezas', humanoid: 'Humanoide',
          'bug-wings': 'Alas insecto', armor: 'Armadura',
        },
        habitatVal: {
          cave: 'Cueva', forest: 'Bosque', grassland: 'Pradera',
          mountain: 'Montaña', rare: 'Raro', 'rough-terrain': 'Terreno escarpado',
          sea: 'Mar', urban: 'Urbano', 'waters-edge': 'Orilla del agua',
        },
        growthVal: {
          slow: 'Lento', 'medium-slow': 'Medio-lento', medium: 'Medio',
          fast: 'Rápido', 'medium-fast': 'Medio-rápido',
          'slow-then-very-fast': 'Lento luego muy rápido',
          'fast-then-very-slow': 'Rápido luego muy lento',
          erratic: 'Errático', fluctuating: 'Fluctuante',
        },
      },

      gender: {
        neutral:   'Sin género',
        maleOnly:  '100% Macho',
        femaleOnly:'100% Hembra',
        ratio:     '♂ {male}% · ♀ {female}%',
      },

      badge: {
        legendary:     'Legendario ✨',
        mythical:      'Mítico 🌟',
        baby:          'Bebé 🍼',
        hiddenAbility: 'Habilidad oculta',
        babyEvo:       'Bebé',
        default:       '(defecto)',
      },

      section: {
        baseStats:       'Estadísticas base',
        abilities:       'Habilidades',
        breeding:        'Cría',
        pastTypes:       'Tipos anteriores',
        pokedexNumbers:  'Números Pokédex',
        varieties:       'Variedades / Formas',
        palPark:         'Parque Amigo',
        gameIndices:     'Índices de juego',
        movesTitle:      'Movimientos ({count} en total)',
        sprites:         'Galería de sprites',
        evoChain:        'Cadena evolutiva',
        pokedexDesc:     'Entrada Pokédex',
        cries:           'Gritos (sonidos)',
        encountersTitle: 'Zonas de encuentro ({count})',
        languagesTitle:  'Nombres en todos los idiomas ({count})',
      },

      breeding: {
        eggGroups:    'Grupos huevo',
        hatchCounter: 'Ciclos de eclosión',
        cycles:       'ciclos',
        steps:        'pasos',
      },

      pastTypes: { before: 'Antes de la generación {gen}' },
      moves: { level: 'Niv.', move: 'Movimiento' },
      palPark: { scoreRate: 'Puntos {score} · Tasa {rate}' },

      sprite: {
        normal:              'Normal',
        back:                'Espalda',
        shiny:               'Shiny',
        shinyBack:           'Shiny espalda',
        female:              'Hembra',
        femaleBack:          'Hembra espalda',
        shinyFemale:         'Shiny hembra',
        officialArtwork:     'Arte oficial',
        officialArtworkShiny:'Arte oficial shiny',
        home:                'HOME',
        homeShiny:           'HOME Shiny',
        showdown:            'Showdown',
        showdownShiny:       'Showdown Shiny',
        dreamWorld:          'Mundo Sueño',
      },

      flavor: { noDesc: 'Sin descripción para este idioma/versión.' },
      cries: { latest: 'Grito actual', legacy: 'Grito antiguo' },
      encounters: { notWild: 'Este Pokémon no se encuentra en estado salvaje.' },

      evo: {
        level:         'Niv. {level}',
        useItem:       'Usar: {item}',
        holdItem:      'Sostener: {item}',
        trade:         'Intercambio',
        happiness:     'Felicidad ≥ {value}',
        beauty:        'Belleza ≥ {value}',
        affection:     'Afecto ≥ {value}',
        knownMove:     'Conoce: {move}',
        knownMoveType: 'Tipo conocido: {type}',
        location:      'Lugar: {location}',
        timeOfDay:     'Momento: {time}',
        femaleOnly:    'Solo hembra',
        maleOnly:      'Solo macho',
        rain:          'Bajo la lluvia',
        upsideDown:    'DS al revés',
        partySpecies:  'Con: {species}',
        partyType:     'Tipo en equipo: {type}',
        tradeSpecies:  'Intercambio con: {species}',
      },
    },
    classicGameDesc: '¡Un Pokémon misterioso se esconde! Adivínalo escribiendo nombres. Cada intento te da pistas: tipo, generación, color, tamaño… ¡Cuanto más cerca estés, más casillas se iluminan!',
    classic: {
      won: '{name} — ¡encontrado en {count} intento{s}!',
      col: {
        name:           'Pokémon',
        types:          'Tipos',
        generation:     'Generación',
        color:          'Color',
        shape:          'Forma',
        evolutionStage: 'Etapa',
        height:         'Altura',
        weight:         'Peso',
      },
      color: {
        black: 'Schwarz', blue: 'Blau', brown: 'Braun', gray: 'Grau',
        green: 'Grün', pink: 'Rosa', purple: 'Lila', red: 'Rot',
        white: 'Weiß', yellow: 'Gelb',
      },
      shape: {
        ball: 'Kugel', squiggle: 'Kurve', fish: 'Fisch',
        arms: 'Arme', blob: 'Klumpen', upright: 'Aufrecht',
        legs: 'Beine', quadruped: 'Vierfüßer', wings: 'Flügel',
        tentacles: 'Tentakel', heads: 'Köpfe', humanoid: 'Humanoid',
        'bug-wings': 'Insektenflügel', armor: 'Rüstung',
      },
      hint: {
        title:          'Pistas desbloqueadas',
        firstLetter:    'Primera letra',
        type:           'Tipo principal',
        generation:     'Generación',
        evolutionStage: 'Etapa de evolución',
        cry:            'Grito del Pokémon',
        silhouette:     'Silueta',
        next:           'Próxima pista en {remaining} intento{s}',
      },
    },

    authModal:{
      loginTitle: 'Accesso',
      registerTitle: 'Registrazione',
      forgotTitle: 'Password dimenticata?',
      usernameLabel: 'Nome utente',
      emailLabel: 'Email',
      passwordLabel: 'Password',
      usernamePlaceholder: 'Scegli il tuo nome da allenatore',
      emailPlaceholder: 'pokemon@master.com',
      passwordPlaceholder: 'La tua password',
      submitLogin: 'Catturali tutti!',
      submitRegister: 'Crea la mia squadra',
      submitting: 'Catturando...',
      sendReset: 'Invia link reset',
      sending: 'Invio in corso...',
      backToLogin: '← Torna al login',
      forgotPassword: 'Password dimenticata?',
      createAccount: 'Crea account',
      loginInstead: 'Accedi',
      noAccount: 'Nessuna squadra ancora?',
      hasAccount: 'Già allenatore?',
      emailRequired: 'Email richiesta',
      emailInvalid: 'Email non valida',
      passwordRequired: 'Password richiesta',
      passwordMin: 'Minimo 6 caratteri',
      usernameMin: 'Nome utente min 3 caratteri',
      emailNotFound: 'Email non trovata',
      requestTimeout: 'Richiesta troppo lunga (10s)',
      networkError: 'Errore rete. Controlla connessione.',
      generalError: 'Errore richiesta',
      resetSent: 'Link reset inviato! Controlla email.',
      showPassword: 'Mostra password',
      hidePassword: 'Nascondi password',
    },
    resetPassword: {
      title: 'Restablecer Contraseña',
      emailLabel: 'Email',
      emailPlaceholder: 'tu@email.com',
      newPasswordLabel: 'Nueva Contraseña',
      newPasswordPlaceholder: 'Nueva contraseña (min 6)',
      confirmLabel: 'Confirmar',
      confirmPlaceholder: 'Confirma contraseña',
      submitButton: 'Restablecer',
      submitting: 'Restableciendo...',
      closeButton: 'Cerrar',
      passwordMismatch: 'Las contraseñas no coinciden',
      passwordTooShort: 'Contraseña muy corta (min 6 caracteres)',
      successMessage: '¡Contraseña restablecida! Redirigiendo...',
      resetError: 'Error al restablecer',
    },
  },

  it: {
    home:              'Home',
    pokedex:           '📋 Pokédex',
    miniGames:         '🎮 Mini-Giochi',
    tactics:           '⚔️ Tattiche',

    welcome:           'Benvenuto, Allenatore',
    subtitle:          'Cattura, combatti ed esplora il mondo Pokémon.\nLa tua avventura inizia qui.',
    launchSafari:      'Avvia PokeWordle',
    openPokedex:       'Apri Pokédex',

    availablePokemons: 'Pokémon disponibili',
    legendaries:       'Leggendari',
    generations:       'Generazioni',
    miniGamesLabel:    'Mini-Giochi',

    pokemonOfDay:      'Pokémon del Giorno',
    dailyRenewal:      'Rinnovo giornaliero',

    types: {
      fire: 'Fuoco', water: 'Acqua', grass: 'Erba', electric: 'Elettro',
      psychic: 'Psico', ice: 'Ghiaccio', dragon: 'Drago', dark: 'Buio',
      fairy: 'Folletto', normal: 'Normale', fighting: 'Lotta', flying: 'Volante',
      poison: 'Veleno', ground: 'Terra', rock: 'Roccia', bug: 'Coleottero',
      ghost: 'Spettro', steel: 'Acciaio'
    },

    ficheTitle:        'Scheda Strategica di',
    recommendedRole:   'Ruolo consigliato',
    natureBuild:       'Natura',
    evsBuild:          'EVs',
    itemBuild:         'Oggetto',
    weaknesses:        'Debolezze',
    resistances:       'Resistenze',
    immunities:        'Immunità',

    tierUberDesc:      'Leggendario dominante',
    tierOUDesc:        'Molto competitivo',
    tierUUDesc:        'Competitivo solido',
    tierRUDesc:        'Uso regionale',
    tierNUDesc:        'Accessibile a tutti',

    roleAttack:        'Attaccante Fisico',
    roleSpAtk:         'Attaccante Speciale',
    roleDefense:       'Muro Fisico',
    roleSpDef:         'Muro Speciale',
    roleSpeed:         'Sweeper Veloce',
    roleHp:            'Tank Generale',

    natureJovial:      'Audace (+Atk)',
    natureModeste:     'Modesto (+Atk.Sp)',
    natureImpudent:    'Ardito (+Def)',
    natureDoux:        'Calmo (+Dif.Sp)',
    natureTimide:      'Timido (+Vel)',
    naturePrudent:     'Cauto (+Dif.Sp)',

    itemCeinture:      'Fascia Scelta',
    itemLunette:       'Occhiali Scelti',
    itemRestes:        'Avanzi',
    itemFoulard:       'Fazzoletto Scelto',

    statHp:            'PS',
    statAtk:           'ATK',
    statDef:           'DIF',
    statSpAtk:         'ATK.SP',
    statSpDef:         'DIF.SP',
    statSpeed:         'VEL',

    navHome: 'Home',
    navPokedex: 'Pokédex',
    navGames: 'Mini Giochi',
    navLegendaries: 'Lendari',

    featuresTitle: 'Scegli la tua Avventura',
    featuresSubtitle: 'Diversi modi per esplorare il mondo Pokémon',
    featureSafari: 'Zona Safari',
    featureSafariDesc: 'Cattura Pokémon selvatici, costruisci la tua squadra e affronta Boss leggendari.',
    featurePokedex: 'Pokédex',
    featurePokedexDesc: 'Esplora il database completo di oltre 1000 Pokémon con statistiche, tipi ed evoluzioni.',
    featureQuiz: 'Quiz Pokémon',
    featureQuizDesc: 'Metti alla prova le tue conoscenze! Silhouette, versi, tipi… Riuscirai a riconoscerli tutti?',
    featureTeamBuilder: 'Costruttore di Squadre',
    featureTeamBuilderDesc: 'Costruisci e ottimizza la tua squadra competitiva con analisi dei tipi e sinergie.',
    featureSafariBadge: 'IDLE RPG',
    featurePokedexBadge: 'ENCICLOPEDIA',
    featureComingSoon: 'PRESTO',
    featurePlay: 'Scoprire',
    featureSafariStats: 'Cattura & Combattimento',
    featurePokedexStats: '1000+ Pokémon',
    featureQuizStats: 'Indovinelli & Punteggio',
    featureTeamStats: 'Strategia',

    pokedexPreviewTitle: 'Anteprima Pokédex',
    pokedexPreviewSubtitle: '{count} Pokémon ti attendono',
    pokedexPreviewButton: 'Vedi tutti i {count} Pokémon',

    historyTitle:   'Cronologia',
    continueButton: 'Gioca ancora',
    defeatTitle:    'Sconfitta',
    pointsGained:   'Punti +{points}',
    victoryTitle:   'Vittoria',

    pokedexKeys: {
      selectGeneration: 'Seleziona una generazione',
      allGenerations: 'Tutte',
      searchPokemon: 'Cerca un Pokémon...',
      noPokemonFound: 'Nessun Pokémon trovato',
      filterType: 'Tipo',
      filterColor: 'Colore',
      sortBy: 'Ordina per',
      sortNumber: 'Numero (ID)',
      sortNameAsc: 'Nome (A-Z)',
      sortNameDesc: 'Nome (Z-A)',
      sortTotalStatsDesc: 'Stat. totali (↓)',
      sortTotalStatsAsc: 'Stat. totali (↑)',
      sortHpDesc: 'PS (↓)',
      sortHpAsc: 'PS (↑)',
      sortAttackDesc: 'Attacco (↓)',
      sortAttackAsc: 'Attacco (↑)',
      sortDefenseDesc: 'Difesa (↓)',
      sortDefenseAsc: 'Difesa (↑)',
      sortSpAtkDesc: 'Atk.Sp. (↓)',
      sortSpAtkAsc: 'Atk.Sp. (↑)',
      sortSpDefDesc: 'Dif.Sp. (↓)',
      sortSpDefAsc: 'Dif.Sp. (↑)',
      sortSpeedDesc: 'Velocità (↓)',
      sortSpeedAsc: 'Velocità (↑)',
      normal: 'Normale', fire: 'Fuoco', water: 'Acqua', grass: 'Erba',
      electric: 'Elettro', ice: 'Ghiaccio', fighting: 'Lotta', poison: 'Veleno',
      ground: 'Terra', flying: 'Volante', psychic: 'Psico', bug: 'Coleottero',
      rock: 'Roccia', ghost: 'Spettro', dragon: 'Drago', dark: 'Buio',
      steel: 'Acciaio', fairy: 'Folletto',
      black: 'Nero', blue: 'Blu', brown: 'Marrone', gray: 'Grigio',
      green: 'Verde', pink: 'Rosa', purple: 'Viola', red: 'Rosso',
      white: 'Bianco', yellow: 'Giallo'
    },

    gameModes: 'Modalità di Gioco',
    gameSubtitle: 'Testa le tue conoscenze Pokémon!',
    
    shadow: 'Silhouette',
    shadowDesc: 'Indovina il Pokémon dalla sua ombra sfocata',
    
    description: 'Descrizione',
    
    type: 'Tipi',
    typeDesc: 'Trova tutti i tipi per eliminazione',
    
    hangman: 'Impiccato',
    hangmanDesc: 'Impiccato classico con nomi Pokémon',
    
    memory: 'Memory',
    memoryDesc: 'Abbina coppie Pokémon',
    
    higherLower: 'Più Alto o Più Basso',
    higherLowerDesc: 'Indovina quale Pokémon è più pesante',
    
    typeChallenge: 'Sfida Tipi',
    typeChallengeDesc: 'Identifica tipi sotto pressione temporale',
    
    safariZone: 'Zona Safari',
    safariZoneDesc: 'Clicker idle e costruttore di squadra',
    
    descriptionDesc: 'Descrizione non disponibile',
    Quitter: 'Esci',
    Score: 'Punteggio',
    Essais: 'Tentativi',
    Valider: 'Valida',
    Continuer: 'Continua',
    Rejouer: 'Rigiuoca',

    quitButton: 'Esci',
    scoreLabel: 'Punteggio',
    attemptsLabel: 'Tentativi',
    higherLowerTitle: '+ o - ?',
    heavierButton: 'Più pesante',
    lighterButton: 'Più leggero',
    vs: 'VS',
    retryButton: 'Riprova',
    memoryTitle: 'Memoria Pokémon',
    pairsLabel: 'Coppie',
    shadowTitle: 'Ombra',
    typeGameTitle: 'Trova i Tipi',
    toFind: 'da trovare',
    validateButton: 'Valida',
    loading: 'Caricamento...',
    searchPokemon: 'Nome del Pokémon...', 
    arcadeRetry: 'Riprova',
    timeUpMessage: 'Tempo scaduto! Il tuo punteggio: {score}',
    typeQuestionPrefix: 'Di che tipo è ',
    weightUnit: 'kg',

    fp: {
      loading: 'Caricamento completo...',
      error:   'Impossibile caricare i dati.',

      tab: {
        stats:      'Stats',
        moves:      'Mosse',
        sprites:    'Sprite',
        evolution:  'Evoluzione',
        pokedex:    'Pokédex',
        encounters: 'Incontri',
        languages:  'Lingue',
      },

      stat: {
        hp:               'PS',
        attack:           'Attacco',
        defense:          'Difesa',
        'special-attack': 'Att. Sp.',
        'special-defense':'Dif. Sp.',
        speed:            'Velocità',
        total:            'Totale',
      },

      qi: {
        height:         'Altezza',
        weight:         'Peso',
        baseExp:        'Esp. base',
        captureRate:    'Tasso cattura',
        baseHappiness:  'Amicizia base',
        growthRate:     'Crescita',
        hatchSteps:     'Passi schiusa',
        hatchStepsValue:'{steps} passi',
        gender:         'Genere',
        color:          'Colore',
        shape:          'Forma',
        habitat:        'Habitat',
        generation:     'Generazione',
        evolvesFrom:    'Si evolve da',
        genderDiff:     'Differenze di genere',
        switchableForms:'Forme intercambiabili',
        yes:            'Sì',
        colorVal: {
          black: 'Nero', blue: 'Blu', brown: 'Marrone', gray: 'Grigio',
          green: 'Verde', pink: 'Rosa', purple: 'Viola', red: 'Rosso',
          white: 'Bianco', yellow: 'Giallo',
        },
        shapeVal: {
          ball: 'Palla', squiggle: 'Serpente', fish: 'Pesce',
          arms: 'Braccia', blob: 'Massa', upright: 'Eretto',
          legs: 'Zampe', quadruped: 'Quadrupede', wings: 'Alato',
          tentacles: 'Tentacoli', heads: 'Teste', humanoid: 'Umanoide',
          'bug-wings': 'Ali insetto', armor: 'Armatura',
        },
        habitatVal: {
          cave: 'Grotta', forest: 'Foresta', grassland: 'Prato',
          mountain: 'Montagna', rare: 'Raro', 'rough-terrain': 'Terreno accidentato',
          sea: 'Mare', urban: 'Urbano', 'waters-edge': 'Riva dell\'acqua',
        },
        growthVal: {
          slow: 'Lento', 'medium-slow': 'Medio-lento', medium: 'Medio',
          fast: 'Rapido', 'medium-fast': 'Medio-rapido',
          'slow-then-very-fast': 'Lento poi velocissimo',
          'fast-then-very-slow': 'Rapido poi lentissimo',
          erratic: 'Erratico', fluctuating: 'Fluttuante',
        },
      },

      gender: {
        neutral:   'Senza genere',
        maleOnly:  '100% Maschio',
        femaleOnly:'100% Femmina',
        ratio:     '♂ {male}% · ♀ {female}%',
      },

      badge: {
        legendary:     'Leggendario ✨',
        mythical:      'Mitico 🌟',
        baby:          'Baby 🍼',
        hiddenAbility: 'Abilità nascosta',
        babyEvo:       'Baby',
        default:       '(default)',
      },

      section: {
        baseStats:       'Statistiche base',
        abilities:       'Abilità',
        breeding:        'Allevamento',
        pastTypes:       'Tipi passati',
        pokedexNumbers:  'Numeri Pokédex',
        varieties:       'Varietà / Forme',
        palPark:         'Parco Amico',
        gameIndices:     'Indici di gioco',
        movesTitle:      'Mosse ({count} in totale)',
        sprites:         'Galleria sprite',
        evoChain:        'Linea evolutiva',
        pokedexDesc:     'Scheda Pokédex',
        cries:           'Versi (suoni)',
        encountersTitle: 'Zone di incontro ({count})',
        languagesTitle:  'Nomi in tutte le lingue ({count})',
      },

      breeding: {
        eggGroups:    'Gruppi uovo',
        hatchCounter: 'Cicli di schiusa',
        cycles:       'cicli',
        steps:        'passi',
      },

      pastTypes: { before: 'Prima della generazione {gen}' },
      moves: { level: 'Liv.', move: 'Mossa' },
      palPark: { scoreRate: 'Punteggio {score} · Tasso {rate}' },

      sprite: {
        normal:              'Normale',
        back:                'Retro',
        shiny:               'Shiny',
        shinyBack:           'Shiny retro',
        female:              'Femmina',
        femaleBack:          'Femmina retro',
        shinyFemale:         'Shiny femmina',
        officialArtwork:     'Artwork ufficiale',
        officialArtworkShiny:'Artwork shiny',
        home:                'HOME',
        homeShiny:           'HOME Shiny',
        showdown:            'Showdown',
        showdownShiny:       'Showdown Shiny',
        dreamWorld:          'Dream World',
      },

      flavor: { noDesc: 'Nessuna descrizione per questa lingua/versione.' },
      cries: { latest: 'Verso attuale', legacy: 'Verso classico' },
      encounters: { notWild: 'Questo Pokémon non si trova allo stato selvatico.' },

      evo: {
        level:         'Liv. {level}',
        useItem:       'Usa: {item}',
        holdItem:      'Tieni: {item}',
        trade:         'Scambio',
        happiness:     'Amicizia ≥ {value}',
        beauty:        'Bellezza ≥ {value}',
        affection:     'Affetto ≥ {value}',
        knownMove:     'Conosce: {move}',
        knownMoveType: 'Tipo noto: {type}',
        location:      'Luogo: {location}',
        timeOfDay:     'Momento: {time}',
        femaleOnly:    'Solo femmina',
        maleOnly:      'Solo maschio',
        rain:          'Sotto la pioggia',
        upsideDown:    'DS capovolto',
        partySpecies:  'Con: {species}',
        partyType:     'Tipo nel team: {type}',
        tradeSpecies:  'Scambio con: {species}',
      },
    },
    classicGameDesc: 'Un Pokémon misterioso si nasconde! Indovinalo digitando dei nomi. Ogni tentativo ti dà indizi: tipo, generazione, colore, dimensioni… Più sei vicino, più celle si illuminano!',
    classic: {
      won: '{name} — trovato in {count} tentativo{s}!',
      col: {
        name:           'Pokémon',
        types:          'Tipi',
        generation:     'Generazione',
        color:          'Colore',
        shape:          'Forma',
        evolutionStage: 'Stadio',
        height:         'Altezza',
        weight:         'Peso',
      },
      color: {
        black: 'Nero', blue: 'Blu', brown: 'Marrone', gray: 'Grigio',
        green: 'Verde', pink: 'Rosa', purple: 'Viola', red: 'Rosso',
        white: 'Bianco', yellow: 'Giallo',
      },
      shape: {
        ball: 'Palla', squiggle: 'Serpente', fish: 'Pesce',
        arms: 'Braccia', blob: 'Massa', upright: 'Eretto',
        legs: 'Zampe', quadruped: 'Quadrupede', wings: 'Ali',
        tentacles: 'Tentacoli', heads: 'Teste', humanoid: 'Umanoide',
        'bug-wings': 'Ali insetto', armor: 'Armatura',
      },
      hint: {
        title:          'Pistas desbloqueadas',
        firstLetter:    'Primera letra',
        type:           'Tipo principal',
        generation:     'Generación',
        evolutionStage: 'Etapa de evolución',
        cry:            'Grito del Pokémon',
        silhouette:     'Silueta',
        next:           'Próxima pista en {remaining} intento{s}',
      },
    },

    authModal:{
      loginTitle: 'Accesso',
      registerTitle: 'Registrazione',
      forgotTitle: 'Password dimenticata?',
      usernameLabel: 'Nome utente',
      emailLabel: 'Email',
      passwordLabel: 'Password',
      usernamePlaceholder: 'Scegli il tuo nome da allenatore',
      emailPlaceholder: 'pokemon@master.com',
      passwordPlaceholder: 'La tua password',
      submitLogin: 'Catturali tutti!',
      submitRegister: 'Crea la mia squadra',
      submitting: 'Catturando...',
      sendReset: 'Invia link reset',
      sending: 'Invio in corso...',
      backToLogin: '← Torna al login',
      forgotPassword: 'Password dimenticata?',
      createAccount: 'Crea account',
      loginInstead: 'Accedi',
      noAccount: 'Nessuna squadra ancora?',
      hasAccount: 'Già allenatore?',
      emailRequired: 'Email richiesta',
      emailInvalid: 'Email non valida',
      passwordRequired: 'Password richiesta',
      passwordMin: 'Minimo 6 caratteri',
      usernameMin: 'Nome utente min 3 caratteri',
      emailNotFound: 'Email non trovata',
      requestTimeout: 'Richiesta troppo lunga (10s)',
      networkError: 'Errore rete. Controlla connessione.',
      generalError: 'Errore richiesta',
      resetSent: 'Link reset inviato! Controlla email.',
      showPassword: 'Mostra password',
      hidePassword: 'Nascondi password',
    },
    resetPassword: {
      title: 'Reimposta Password',
      emailLabel: 'Email',
      emailPlaceholder: 'tuo@email.com',
      newPasswordLabel: 'Nuova Password',
      newPasswordPlaceholder: 'Nuova password (min 6)',
      confirmLabel: 'Conferma',
      confirmPlaceholder: 'Conferma password',
      submitButton: 'Reimposta',
      submitting: 'Reimpostazione...',
      closeButton: 'Chiudi',
      passwordMismatch: 'Le password non corrispondono',
      passwordTooShort: 'Password troppo corta (min 6 caratteri)',
      successMessage: 'Password reimpostata! Reindirizzamento...',
      resetError: 'Errore reimpostazione',
    },
  },

  ja: {
    home:              'ホーム',
    pokedex:           '📋 図鑑',
    miniGames:         '🎮 ミニゲーム',
    tactics:           '⚔️ タクティクス',

    welcome:           'ようこそ、トレーナー',
    subtitle:          'ポケモンの世界を冒険しよう。\nあなたの旅はここから始まる。',
    launchSafari:      'サファリゾーンへ',
    openPokedex:       '図鑑を開く',

    availablePokemons: '利用可能なポケモン',
    legendaries:       '伝説のポケモン',
    generations:       '世代',
    miniGamesLabel:    'ミニゲーム',

    pokemonOfDay:      '今日のポケモン',
    dailyRenewal:      '毎日更新',

    types: {
      fire: 'ほのお', water: 'みず', grass: 'くさ', electric: 'でんき',
      psychic: 'エスパー', ice: 'こおり', dragon: 'ドラゴン', dark: 'あく',
      fairy: 'フェアリー', normal: 'ノーマル', fighting: 'かくとう', flying: 'ひこう',
      poison: 'どく', ground: 'じめん', rock: 'いわ', bug: 'むし',
      ghost: 'ゴースト', steel: 'はがね'
    },

    ficheTitle:        '戦略シート：',
    recommendedRole:   'おすすめの役割',
    natureBuild:       'せいかく',
    evsBuild:          '努力値',
    itemBuild:         'もちもの',
    weaknesses:        '弱点',
    resistances:       '耐性',
    immunities:        '無効',

    tierUberDesc:      '圧倒的な伝説',
    tierOUDesc:        '非常に競争力が高い',
    tierUUDesc:        '安定した競争力',
    tierRUDesc:        '地域での使用',
    tierNUDesc:        '誰でも使いやすい',

    roleAttack:        '物理アタッカー',
    roleSpAtk:         '特殊アタッカー',
    roleDefense:       '物理受け',
    roleSpDef:         '特殊受け',
    roleSpeed:         'スピードスイーパー',
    roleHp:            '総合タンク',

    natureJovial:      'いじっぱり (+こうげき)',
    natureModeste:     'ひかえめ (+とくこう)',
    natureImpudent:    'ずぶとい (+ぼうぎょ)',
    natureDoux:        'おだやか (+とくぼう)',
    natureTimide:      'おくびょう (+すばやさ)',
    naturePrudent:     'しんちょう (+とくぼう)',

    itemCeinture:      'こだわりハチマキ',
    itemLunette:       'こだわりメガネ',
    itemRestes:        'たべのこし',
    itemFoulard:       'こだわりスカーフ',

    statHp:            'HP',
    statAtk:           'こうげき',
    statDef:           'ぼうぎょ',
    statSpAtk:         'とくこう',
    statSpDef:         'とくぼう',
    statSpeed:         'すばやさ',

    navHome: 'ホーム',
    navPokedex: 'ポケデックス',
    navGames: 'ミニゲーム',
    navLegendaries: '伝説のポケモン',

    featuresTitle: '冒険を選ぶ',
    featuresSubtitle: 'ポケモンの世界を探検するさまざまな方法',
    featureSafari: 'サファリゾーン',
    featureSafariDesc: '野生のポケモンを捕まえ、チームを構築し、伝説のボスと戦う。',
    featurePokedex: 'ポケモン図鑑',
    featurePokedexDesc: '1000以上のポケモンのステータス、タイプ、進化を含む完全なデータベースを探索。',
    featureQuiz: 'ポケモンクイズ',
    featureQuizDesc: 'シルエット、鳴き声、タイプで知識をテスト！すべて認識できる？',
    featureTeamBuilder: 'チームビルダー',
    featureTeamBuilderDesc: 'タイプ分析とシナジーで競技チームを構築・最適化。',
    featureSafariBadge: '放置RPG',
    featurePokedexBadge: '図鑑',
    featureComingSoon: '近日公開',
    featurePlay: '発見',
    featureSafariStats: '捕獲＆戦闘',
    featurePokedexStats: '1000+ポケモン',
    featureQuizStats: '謎解き＆スコア',
    featureTeamStats: '戦略',

    pokedexPreviewTitle: '図鑑プレビュー',
    pokedexPreviewSubtitle: '{count}匹のポケモンがお待ちしています',
    pokedexPreviewButton: '{count}匹のポケモンを見る',

    historyTitle:   'りれき',
    continueButton: 'もう一度あそぶ',
    defeatTitle:    'はいぼく',
    pointsGained: 'ポイント +{points}',
    victoryTitle:   'しょうり',

    pokedexKeys: {
      selectGeneration: '世代を選択',
      allGenerations: 'すべて',
      searchPokemon: 'ポケモンを検索...',
      noPokemonFound: 'ポケモンが見つかりません',
      filterType: 'タイプ',
      filterColor: '色',
      sortBy: '並び替え',
      sortNumber: '番号 (ID)',
      sortNameAsc: '名前 (あ-お)',
      sortNameDesc: '名前 (お-あ)',
      sortTotalStatsDesc: '総合ステータス (↓)',
      sortTotalStatsAsc: '総合ステータス (↑)',
      sortHpDesc: 'HP (↓)',
      sortHpAsc: 'HP (↑)',
      sortAttackDesc: '攻撃 (↓)',
      sortAttackAsc: '攻撃 (↑)',
      sortDefenseDesc: '防御 (↓)',
      sortDefenseAsc: '防御 (↑)',
      sortSpAtkDesc: '特攻 (↓)',
      sortSpAtkAsc: '特攻 (↑)',
      sortSpDefDesc: '特防 (↓)',
      sortSpDefAsc: '特防 (↑)',
      sortSpeedDesc: '素早さ (↓)',
      sortSpeedAsc: '素早さ (↑)',
      normal: 'ノーマル', fire: 'ほのお', water: 'みず', grass: 'くさ',
      electric: 'でんき', ice: 'こおり', fighting: 'かくとう', poison: 'どく',
      ground: 'じめん', flying: 'ひこう', psychic: 'エスパー', bug: 'むし',
      rock: 'いわ', ghost: 'ゴースト', dragon: 'ドラゴン', dark: 'あく',
      steel: 'はがね', fairy: 'フェアリー',
      black: '黒', blue: '青', brown: '茶', gray: '灰',
      green: '緑', pink: 'ピンク', purple: '紫', red: '赤',
      white: '白', yellow: '黄'
    },

    gameModes: 'ゲームモード',
    gameSubtitle: 'ポケモンの知識を試そう！',
    
    // shadow
    shadow: 'シルエット',
    shadowDesc: 'ぼやけたシルエットからポケモンを当てる',
    
    // description
    description: '説明',
    
    // type
    type: 'タイプ',
    typeDesc: '全タイプを見つけ出す',
    
    // hangman
    hangman: 'ハングマン',
    hangmanDesc: 'ポケモン名でハングマン',
    
    // memory
    memory: 'メモリー',
    memoryDesc: 'ポケモンのペアを合わせる',
    
    // higher-lower
    higherLower: '重さ当て',
    higherLowerDesc: 'どっちのポケモンが重いか当てる',
    
    // type-challenge
    typeChallenge: 'タイプチャレンジ',
    typeChallengeDesc: '時間制限でタイプを特定',
    
    // safarizone
    safariZone: 'サファリゾーン',
    safariZoneDesc: '放置クリック＆チーム構築',
    
    // Shared/UI
    descriptionDesc: '説明文がありません',
    Quitter: '終了',
    Score: 'スコア',
    Essais: '試行回数',
    Valider: '決定',
    Continuer: '次へ',
    Rejouer: 'もう一度',

    quitButton: '終了',
    scoreLabel: 'スコア',
    attemptsLabel: '試行回数',
    higherLowerTitle: '重い？軽い？',
    heavierButton: '重い',
    lighterButton: '軽い',
    vs: 'VS',
    retryButton: 'リトライ',
    memoryTitle: 'ポケモンメモリー',
    pairsLabel: 'ペア',
    shadowTitle: '影',
    typeGameTitle: 'タイプを当てろ！',
    toFind: '種類',
    validateButton: '決定',
    loading: '読み込み中...',
    searchPokemon: 'ポケモンの名前...',
    arcadeRetry: '再挑戦',
    timeUpMessage: 'タイムアップ！ スコア: {score}',
    typeQuestionPrefix: 'のタイプは？ ',
    weightUnit: 'キログラム',

    fp: {
      loading: 'データを読み込み中...',
      error:   'データを読み込めませんでした。',

      tab: {
        stats:      'ステータス',
        moves:      'わざ',
        sprites:    'スプライト',
        evolution:  'しんか',
        pokedex:    'ずかん',
        encounters: '出現場所',
        languages:  '言語',
      },

      stat: {
        hp:               'HP',
        attack:           'こうげき',
        defense:          'ぼうぎょ',
        'special-attack': 'とくこう',
        'special-defense':'とくぼう',
        speed:            'すばやさ',
        total:            'ごうけい',
      },

      qi: {
        height:         'たかさ',
        weight:         'おもさ',
        baseExp:        '基本経験値',
        captureRate:    '捕捉率',
        baseHappiness:  '基本なつき度',
        growthRate:     '成長速度',
        hatchSteps:     '孵化歩数',
        hatchStepsValue:'{steps}歩',
        gender:         '性別',
        color:          '色',
        shape:          'かたち',
        habitat:        '生息地',
        generation:     '世代',
        evolvesFrom:    '進化前',
        genderDiff:     '性別による違い',
        switchableForms:'フォルムチェンジ可',
        yes:            'あり',
        colorVal: {
          black: '黒', blue: '青', brown: '茶', gray: '灰',
          green: '緑', pink: 'ピンク', purple: '紫', red: '赤',
          white: '白', yellow: '黄',
        },
        shapeVal: {
          ball: 'まるい', squiggle: 'くねくね', fish: 'さかな',
          arms: 'うで', blob: 'かたまり', upright: '二足',
          legs: 'あし', quadruped: '四足', wings: 'つばさ',
          tentacles: 'しょくしゅ', heads: 'あたま', humanoid: '人型',
          'bug-wings': 'むしのはね', armor: 'よろい',
        },
        habitatVal: {
          cave: 'どうくつ', forest: 'もり', grassland: 'そうげん',
          mountain: 'やま', rare: 'まれ', 'rough-terrain': 'あれち',
          sea: 'うみ', urban: 'としぶ', 'waters-edge': 'みずべ',
        },
        growthVal: {
          slow: 'おそい', 'medium-slow': 'やや おそい', medium: 'ふつう',
          fast: 'はやい', 'medium-fast': 'やや はやい',
          'slow-then-very-fast': 'おそい→とても はやい',
          'fast-then-very-slow': 'はやい→とても おそい',
          erratic: 'ふきそく', fluctuating: 'へんどう',
        },
      },

      gender: {
        neutral:   '性別なし',
        maleOnly:  '100% オス',
        femaleOnly:'100% メス',
        ratio:     '♂ {male}% · ♀ {female}%',
      },

      badge: {
        legendary:     'でんせつ ✨',
        mythical:      'げんそう 🌟',
        baby:          'ベイビー 🍼',
        hiddenAbility: 'かくれとくせい',
        babyEvo:       'ベイビー',
        default:       '(デフォルト)',
      },

      section: {
        baseStats:       '基本ステータス',
        abilities:       'とくせい',
        breeding:        'そだてや',
        pastTypes:       '過去のタイプ',
        pokedexNumbers:  'ずかん番号',
        varieties:       'バリエーション・フォルム',
        palPark:         'パルパーク',
        gameIndices:     'ゲーム内番号',
        movesTitle:      'わざ（{count}個）',
        sprites:         'スプライト一覧',
        evoChain:        'しんかのけい',
        pokedexDesc:     'ずかん説明',
        cries:           'なき声',
        encountersTitle: '出現場所（{count}か所）',
        languagesTitle:  '各言語の名前（{count}）',
      },

      breeding: {
        eggGroups:    'たまごグループ',
        hatchCounter: '孵化サイクル',
        cycles:       'サイクル',
        steps:        '歩',
      },

      pastTypes: { before: '第{gen}世代より前' },
      moves: { level: 'Lv.', move: 'わざ' },
      palPark: { scoreRate: 'スコア {score} · 率 {rate}' },

      sprite: {
        normal:              'ノーマル',
        back:                'うしろ',
        shiny:               '色違い',
        shinyBack:           '色違い（うしろ）',
        female:              'メス',
        femaleBack:          'メス（うしろ）',
        shinyFemale:         '色違いメス',
        officialArtwork:     '公式アートワーク',
        officialArtworkShiny:'色違いアートワーク',
        home:                'HOME',
        homeShiny:           'HOME 色違い',
        showdown:            'Showdown',
        showdownShiny:       'Showdown 色違い',
        dreamWorld:          'ドリームワールド',
      },

      flavor: { noDesc: 'この言語/バージョンの説明はありません。' },
      cries: { latest: '現在のなき声', legacy: '旧なき声' },
      encounters: { notWild: 'このポケモンは野生では出現しません。' },

      evo: {
        level:         'Lv.{level}',
        useItem:       'つかう: {item}',
        holdItem:      'もたせる: {item}',
        trade:         'こうかん',
        happiness:     'なつき度 ≥ {value}',
        beauty:        '美しさ ≥ {value}',
        affection:     'なかよし度 ≥ {value}',
        knownMove:     'わざを覚えている: {move}',
        knownMoveType: 'タイプのわざ: {type}',
        location:      'ばしょ: {location}',
        timeOfDay:     '時間帯: {time}',
        femaleOnly:    'メスのみ',
        maleOnly:      'オスのみ',
        rain:          'あめのとき',
        upsideDown:    'DSをさかさまに',
        partySpecies:  'いっしょに: {species}',
        partyType:     'パーティのタイプ: {type}',
        tradeSpecies:  '{species}とこうかん',
      },
    },
    classicGameDesc: 'なぞのポケモンがかくれています！なまえをにゅうりょくしてあててみよう。こたえるたびにヒントがもらえます：タイプ、せだい、いろ、おおきさ…ちかいほど、マスがひかります！',
    classic: {
      won: '{name} — {count}回で正解！',
      col: {
        name:           'ポケモン',
        types:          'タイプ',
        generation:     'せだい',
        color:          'いろ',
        shape:          'かたち',
        evolutionStage: 'しんかのだんかい',
        height:         'たかさ',
        weight:         'おもさ',
      },
      color: {
        black: '黒', blue: '青', brown: '茶', gray: '灰',
        green: '緑', pink: 'ピンク', purple: '紫', red: '赤',
        white: '白', yellow: '黄',
      },
      shape: {
        ball: 'まるい', squiggle: 'くねくね', fish: 'さかな',
        arms: 'うで', blob: 'かたまり', upright: '二足',
        legs: 'あし', quadruped: '四足', wings: 'つばさ',
        tentacles: 'しょくしゅ', heads: 'あたま', humanoid: '人型',
        'bug-wings': 'むしのはね', armor: 'よろい',
      },
      hint: {
        title:          'アンロックされたヒント',
        firstLetter:    '名前の最初の文字',
        type:           'メインタイプ',
        generation:     '世代',
        evolutionStage: '進化のだんかい',
        cry:            'なき声',
        silhouette:     'シルエット',
        next:           'あと{remaining}回でヒント解放',
      },
    },
    authModal:{
      loginTitle: 'Iniciar sesión',
      registerTitle: 'Registrarse',
      forgotTitle: '¿Contraseña olvidada?',
      usernameLabel: 'Nombre de usuario',
      emailLabel: 'Email',
      passwordLabel: 'Contraseña',
      usernamePlaceholder: 'Elige tu nombre de entrenador',
      emailPlaceholder: 'pokemon@master.com',
      passwordPlaceholder: 'Tu contraseña',
      submitLogin: '¡Atrápalos todos!',
      submitRegister: 'Crear mi equipo',
      submitting: 'Capturando...',
      sendReset: 'Enviar enlace de restablecimiento',
      sending: 'Enviando...',
      backToLogin: '← Volver al inicio de sesión',
      forgotPassword: '¿Contraseña olvidada?',
      createAccount: 'Crear cuenta',
      loginInstead: 'Iniciar sesión',
      noAccount: '¿Aún sin equipo?',
      hasAccount: '¿Ya eres entrenador?',
      emailRequired: 'Email requerido',
      emailInvalid: 'Email inválido',
      passwordRequired: 'Contraseña requerida',
      passwordMin: 'Mínimo 6 caracteres',
      usernameMin: 'Nombre de usuario mín 3 caracteres',
      emailNotFound: 'Email no encontrado',
      requestTimeout: 'Petición demasiado larga (10s)',
      networkError: 'Error de red. Verifica conexión.',
      generalError: 'Error en la petición',
      resetSent: '¡Enlace de restablecimiento enviado! Revisa tu email.',
      showPassword: 'Mostrar contraseña',
      hidePassword: 'Ocultar contraseña',
    },
    resetPassword: {
      title: 'パスワードリセット',
      emailLabel: 'メールアドレス',
      emailPlaceholder: 'your@email.com',
      newPasswordLabel: '新しいパスワード',
      newPasswordPlaceholder: '新しいパスワード（最低6文字）',
      confirmLabel: '確認',
      confirmPlaceholder: 'パスワード確認',
      submitButton: 'リセット',
      submitting: 'リセット中...',
      closeButton: '閉じる',
      passwordMismatch: 'パスワードが一致しません',
      passwordTooShort: 'パスワードが短すぎます（最低6文字）',
      successMessage: 'パスワードリセット完了！リダイレクト中...',
      resetError: 'リセットエラー',
    },
  },

  ko: {
    home:              '홈',
    pokedex:           '📋 도감',
    miniGames:         '🎮 미니게임',
    tactics:           '⚔️ 전술',

    welcome:           '환영합니다, 트레이너',
    subtitle:          '포켓몬 세계를 탐험하세요.\n당신의 모험이 시작됩니다.',
    launchSafari:      '사파리 존 시작',
    openPokedex:       '포켓몬 도감 열기',

    availablePokemons: '이용 가능한 포켓몬',
    legendaries:       '전설의 포켓몬',
    generations:       '세대',
    miniGamesLabel:    '미니게임',

    pokemonOfDay:      '오늘의 포켓몬',
    dailyRenewal:      '매일 갱신',

    types: {
      fire: '불꽃', water: '물', grass: '풀', electric: '전기',
      psychic: '에스퍼', ice: '얼음', dragon: '드래곤', dark: '악',
      fairy: '페어리', normal: '노말', fighting: '격투', flying: '비행',
      poison: '독', ground: '땅', rock: '바위', bug: '벌레',
      ghost: '고스트', steel: '강철'
    },

    ficheTitle:        '전략 시트：',
    recommendedRole:   '추천 역할',
    natureBuild:       '성격',
    evsBuild:          '노력치',
    itemBuild:         '지닌 도구',
    weaknesses:        '약점',
    resistances:       '저항',
    immunities:        '무효',

    tierUberDesc:      '압도적인 전설',
    tierOUDesc:        '매우 경쟁적',
    tierUUDesc:        '안정적인 경쟁력',
    tierRUDesc:        '지역 사용',
    tierNUDesc:        '누구나 접근 가능',

    roleAttack:        '물리 공격수',
    roleSpAtk:         '특수 공격수',
    roleDefense:       '물리 방어막',
    roleSpDef:         '특수 방어막',
    roleSpeed:         '스피드 스위퍼',
    roleHp:            '종합 탱커',

    natureJovial:      '장난꾸러기 (+공격)',
    natureModeste:     '차분한 (+특공)',
    natureImpudent:    '뻔뻔한 (+방어)',
    natureDoux:        '온순한 (+특방)',
    natureTimide:      '소심한 (+스피드)',
    naturePrudent:     '신중한 (+특방)',

    itemCeinture:      '구애머리띠',
    itemLunette:       '구애안경',
    itemRestes:        '먹다 남은 음식',
    itemFoulard:       '구애스카프',

    statHp:            'HP',
    statAtk:           '공격',
    statDef:           '방어',
    statSpAtk:         '특공',
    statSpDef:         '특방',
    statSpeed:         '스피드',

    navHome: '홈',
    navPokedex: '포켓몬도감',
    navGames: '미니게임',
    navLegendaries: '전설의 포켓몬',

    featuresTitle: '모험 선택',
    featuresSubtitle: '포켓몬 세계를 탐험하는 여러 방법',
    featureSafari: '사파리 존',
    featureSafariDesc: '야생 포켓몬을 잡고, 팀을 구성하고 전설의 보스와 싸우세요.',
    featurePokedex: '포켓몬 도감',
    featurePokedexDesc: '1000개 이상의 포켓몬 데이터베이스, 스탯, 타입, 진화를 탐험하세요.',
    featureQuiz: '포켓몬 퀴즈',
    featureQuizDesc: '지식 테스트! 실루엣, 울음소리, 타입… 모두 알아 맞힐 수 있나요?',
    featureTeamBuilder: '팀 빌더',
    featureTeamBuilderDesc: '타입 분석과 시너지를 통한 경쟁 팀 구축 및 최적화.',
    featureSafariBadge: '아이들 RPG',
    featurePokedexBadge: '백과사전',
    featureComingSoon: '곧 출시',
    featurePlay: '발견',
    featureSafariStats: '포획 & 전투',
    featurePokedexStats: '1000+ 포켓몬',
    featureQuizStats: '수수께끼 & 점수',
    featureTeamStats: '전략',

    pokedexPreviewTitle: '도감 미리보기',
    pokedexPreviewSubtitle: '{count}마리 포켓몬이 기다립니다',
    pokedexPreviewButton: '{count}마리 포켓몬 보기',

    historyTitle:   '기록',
    continueButton: '다시 플레이',
    defeatTitle:    '패배',
    pointsGained: '포인트 +{points}',
    victoryTitle:   '승리',

    pokedexKeys: {
      selectGeneration: '세대를 선택하세요',
      allGenerations: '전체',
      searchPokemon: '포켓몬 검색...',
      noPokemonFound: '포켓몬을 찾을 수 없습니다',
      filterType: '타입',
      filterColor: '색상',
      sortBy: '정렬 기준',
      sortNumber: '번호 (ID)',
      sortNameAsc: '이름 (가-나)',
      sortNameDesc: '이름 (나-가)',
      sortTotalStatsDesc: '종합 능력치 (↓)',
      sortTotalStatsAsc: '종합 능력치 (↑)',
      sortHpDesc: 'HP (↓)',
      sortHpAsc: 'HP (↑)',
      sortAttackDesc: '공격 (↓)',
      sortAttackAsc: '공격 (↑)',
      sortDefenseDesc: '방어 (↓)',
      sortDefenseAsc: '방어 (↑)',
      sortSpAtkDesc: '특공 (↓)',
      sortSpAtkAsc: '특공 (↑)',
      sortSpDefDesc: '특방 (↓)',
      sortSpDefAsc: '특방 (↑)',
      sortSpeedDesc: '스피드 (↓)',
      sortSpeedAsc: '스피드 (↑)',
      normal: '노말', fire: '불꽃', water: '물', grass: '풀',
      electric: '전기', ice: '얼음', fighting: '격투', poison: '독',
      ground: '땅', flying: '비행', psychic: '에스퍼', bug: '벌레',
      rock: '바위', ghost: '고스트', dragon: '드래곤', dark: '악',
      steel: '강철', fairy: '페어리',
      black: '검정', blue: '파랑', brown: '갈색', gray: '회색',
      green: '초록', pink: '핑크', purple: '보라', red: '빨강',
      white: '흰색', yellow: '노랑'
    },

    // GameMenu
    gameModes: '게임 모드',
    gameSubtitle: '포켓몬 지식을 테스트하세요!',
    
    // shadow
    shadow: '실루엣',
    shadowDesc: '흐릿한 실루엣으로 포켓몬 맞추기',
    
    // description
    description: '설명',
    
    // type
    type: '타입',
    typeDesc: '모든 타입을 찾아내기',
    
    // hangman
    hangman: '행맨',
    hangmanDesc: '포켓몬 이름 행맨 게임',
    
    // memory
    memory: '메모리',
    memoryDesc: '포켓몬 쌍을 맞추기',
    
    // higher-lower
    higherLower: '무게 맞추기',
    higherLowerDesc: '어느 포켓몬이 더 무거운지 맞추기',
    
    // type-challenge
    typeChallenge: '타입 챌린지',
    typeChallengeDesc: '시간 제한 타입 식별',
    
    // safarizone
    safariZone: '사파리 존',
    safariZoneDesc: '아이들 클릭러 & 팀 빌더',
    
    // Shared/UI
    descriptionDesc: '설명 없음',
    Quitter: '종료',
    Score: '점수',
    Essais: '시도횟수',
    Valider: '확인',
    Continuer: '계속',
    Rejouer: '다시하기',

    quitButton: '종료',
    scoreLabel: '점수',
    attemptsLabel: '시도 횟수',
    higherLowerTitle: '무거운? 가벼운?',
    heavierButton: '더 무거운',
    lighterButton: '더 가벼운',
    vs: 'VS',
    retryButton: '다시하기',
    memoryTitle: '포켓몬 메모리',
    pairsLabel: '짝',
    shadowTitle: '그림자',
    typeGameTitle: '타입 맞추기',
    toFind: '찾아야할',
    validateButton: '확인',
    loading: '로딩중...',
    searchPokemon: '포켓몬 이름...', 
    arcadeRetry: '다시 시도',
    timeUpMessage: '시간 초과! 점수: {score}',
    typeQuestionPrefix: '의 타입은 무엇인가요? ',
    weightUnit: 'kg (킬로그램)',

    fp: {
      loading: '데이터 불러오는 중...',
      error:   '데이터를 불러올 수 없습니다.',

      tab: {
        stats:      '스탯',
        moves:      '기술',
        sprites:    '스프라이트',
        evolution:  '진화',
        pokedex:    '도감',
        encounters: '출현 장소',
        languages:  '언어',
      },

      stat: {
        hp:               'HP',
        attack:           '공격',
        defense:          '방어',
        'special-attack': '특수공격',
        'special-defense':'특수방어',
        speed:            '스피드',
        total:            '합계',
      },

      qi: {
        height:         '키',
        weight:         '몸무게',
        baseExp:        '기본 경험치',
        captureRate:    '포획률',
        baseHappiness:  '기본 친밀도',
        growthRate:     '성장 속도',
        hatchSteps:     '부화 걸음 수',
        hatchStepsValue:'{steps}걸음',
        gender:         '성별',
        color:          '색',
        shape:          '형태',
        habitat:        '서식지',
        generation:     '세대',
        evolvesFrom:    '진화 전',
        genderDiff:     '성별 차이',
        switchableForms:'폼 변경 가능',
        yes:            '있음',
        colorVal: {
          black: '검정', blue: '파랑', brown: '갈색', gray: '회색',
          green: '초록', pink: '분홍', purple: '보라', red: '빨강',
          white: '하양', yellow: '노랑',
        },
        shapeVal: {
          ball: '공', squiggle: '구불구불', fish: '물고기',
          arms: '팔', blob: '덩어리', upright: '직립',
          legs: '다리', quadruped: '네발', wings: '날개',
          tentacles: '촉수', heads: '머리', humanoid: '인간형',
          'bug-wings': '곤충 날개', armor: '갑옷',
        },
        habitatVal: {
          cave: '동굴', forest: '숲', grassland: '초원',
          mountain: '산', rare: '희귀', 'rough-terrain': '험지',
          sea: '바다', urban: '도시', 'waters-edge': '수변',
        },
        growthVal: {
          slow: '느림', 'medium-slow': '약간 느림', medium: '보통',
          fast: '빠름', 'medium-fast': '약간 빠름',
          'slow-then-very-fast': '느리다가 매우 빠름',
          'fast-then-very-slow': '빠르다가 매우 느림',
          erratic: '불규칙', fluctuating: '변동',
        },
      },

      gender: {
        neutral:   '무성',
        maleOnly:  '100% 수컷',
        femaleOnly:'100% 암컷',
        ratio:     '♂ {male}% · ♀ {female}%',
      },

      badge: {
        legendary:     '전설 ✨',
        mythical:      '환상 🌟',
        baby:          '베이비 🍼',
        hiddenAbility: '숨겨진 특성',
        babyEvo:       '베이비',
        default:       '(기본)',
      },

      section: {
        baseStats:       '기본 스탯',
        abilities:       '특성',
        breeding:        '육성',
        pastTypes:       '과거 타입',
        pokedexNumbers:  '도감 번호',
        varieties:       '변형 / 폼',
        palPark:         '팔파크',
        gameIndices:     '게임 내 번호',
        movesTitle:      '기술 ({count}개)',
        sprites:         '스프라이트 갤러리',
        evoChain:        '진화 계통',
        pokedexDesc:     '도감 설명',
        cries:           '울음소리',
        encountersTitle: '출현 장소 ({count}곳)',
        languagesTitle:  '모든 언어 이름 ({count})',
      },

      breeding: {
        eggGroups:    '알 그룹',
        hatchCounter: '부화 사이클',
        cycles:       '사이클',
        steps:        '걸음',
      },

      pastTypes: { before: '{gen} 세대 이전' },
      moves: { level: 'Lv.', move: '기술' },
      palPark: { scoreRate: '점수 {score} · 비율 {rate}' },

      sprite: {
        normal:              '일반',
        back:                '뒷모습',
        shiny:               '색이 다른',
        shinyBack:           '색이 다른 뒷모습',
        female:              '암컷',
        femaleBack:          '암컷 뒷모습',
        shinyFemale:         '색이 다른 암컷',
        officialArtwork:     '공식 아트워크',
        officialArtworkShiny:'색이 다른 아트워크',
        home:                'HOME',
        homeShiny:           'HOME 색이 다른',
        showdown:            'Showdown',
        showdownShiny:       'Showdown 색이 다른',
        dreamWorld:          '드림월드',
      },

      flavor: { noDesc: '이 언어/버전에 대한 설명이 없습니다.' },
      cries: { latest: '현재 울음소리', legacy: '구 울음소리' },
      encounters: { notWild: '이 포켓몬은 야생에서 출현하지 않습니다.' },

      evo: {
        level:         'Lv.{level}',
        useItem:       '사용: {item}',
        holdItem:      '지니기: {item}',
        trade:         '교환',
        happiness:     '친밀도 ≥ {value}',
        beauty:        '아름다움 ≥ {value}',
        affection:     '친근함 ≥ {value}',
        knownMove:     '기술 보유: {move}',
        knownMoveType: '타입 기술 보유: {type}',
        location:      '장소: {location}',
        timeOfDay:     '시간대: {time}',
        femaleOnly:    '암컷 전용',
        maleOnly:      '수컷 전용',
        rain:          '비 올 때',
        upsideDown:    'DS 뒤집기',
        partySpecies:  '함께: {species}',
        partyType:     '파티 타입: {type}',
        tradeSpecies:  '{species}와 교환',
      },
    },
    classicGameDesc: '미스터리 포켓몬이 숨어 있어요! 이름을 입력해서 맞춰보세요. 시도할 때마다 힌트가 주어집니다: 타입, 세대, 색, 크기… 가까울수록 칸이 더 밝아져요!',
    classic: {
      won: '{name} — {count}번 만에 정답!',
      col: {
        name:           '포켓몬',
        types:          '타입',
        generation:     '세대',
        color:          '색',
        shape:          '형태',
        evolutionStage: '진화 단계',
        height:         '키',
        weight:         '몸무게',
      },
      color: {
        black: '검정', blue: '파랑', brown: '갈색', gray: '회색',
        green: '초록', pink: '분홍', purple: '보라', red: '빨강',
        white: '하양', yellow: '노랑',
      },
      shape: {
        ball: '공', squiggle: '구불구불', fish: '물고기',
        arms: '팔', blob: '덩어리', upright: '직립',
        legs: '다리', quadruped: '네발', wings: '날개',
        tentacles: '촉수', heads: '머리', humanoid: '인간형',
        'bug-wings': '곤충 날개', armor: '갑옷',
      },
      hint: {
        title:          '해금된 힌트',
        firstLetter:    '이름의 첫 글자',
        type:           '주요 타입',
        generation:     '세대',
        evolutionStage: '진화 단계',
        cry:            '포켓몬 울음소리',
        silhouette:     '실루엣',
        next:           '다음 힌트까지 {remaining}번 남음',
      },
    },
    authModal:{
      loginTitle: '로그인',
      registerTitle: '회원가입',
      forgotTitle: '비밀번호 찾기',
      usernameLabel: '사용자 이름',
      emailLabel: '이메일',
      passwordLabel: '비밀번호',
      usernamePlaceholder: '트레이너 이름 선택',
      emailPlaceholder: 'pokemon@master.com',
      passwordPlaceholder: '당신의 비밀번호',
      submitLogin: '모두 잡아라!',
      submitRegister: '팀 생성',
      submitting: '포획 중...',
      sendReset: '리셋 링크 보내기',
      sending: '전송 중...',
      backToLogin: '← 로그인으로',
      forgotPassword: '비밀번호 분실?',
      createAccount: '계정 생성',
      loginInstead: '로그인',
      noAccount: '아직 팀 없음?',
      hasAccount: '이미 트레이너?',
      emailRequired: '이메일 필수',
      emailInvalid: '잘못된 이메일',
      passwordRequired: '비밀번호 필수',
      passwordMin: '최소 6자',
      usernameMin: '사용자 이름 최소 3자',
      emailNotFound: '이메일 없음',
      requestTimeout: '요청 시간 초과 (10초)',
      networkError: '네트워크 오류. 연결 확인.',
      generalError: '요청 오류',
      resetSent: '리셋 링크 발송! 이메일 확인.',
      showPassword: '비밀번호 표시',
      hidePassword: '비밀번호 숨김',
    },

    resetPassword: {
      title: '비밀번호 재설정',
      emailLabel: '이메일',
      emailPlaceholder: 'your@email.com',
      newPasswordLabel: '새 비밀번호',
      newPasswordPlaceholder: '새 비밀번호 (최소 6자)',
      confirmLabel: '확인',
      confirmPlaceholder: '비밀번호 확인',
      submitButton: '재설정',
      submitting: '재설정 중...',
      closeButton: '닫기',
      passwordMismatch: '비밀번호가 일치하지 않습니다',
      passwordTooShort: '비밀번호가 너무 짧습니다 (최소 6자)',
      successMessage: '비밀번호 재설정 완료! 리다이렉트 중...',
      resetError: '재설정 오류',
    },
  },

  'zh-Hans': {
    home:              '首页',
    pokedex:           '📋 图鉴',
    miniGames:         '🎮 小游戏',
    tactics:           '⚔️ 战术',

    welcome:           '欢迎，训练师',
    subtitle:          '捕捉、战斗并探索宝可梦世界。\n你的冒险从这里开始。',
    launchSafari:      '启动狩猎区',
    openPokedex:       '打开图鉴',

    availablePokemons: '可用宝可梦',
    legendaries:       '传说宝可梦',
    generations:       '世代',
    miniGamesLabel:    '小游戏',

    pokemonOfDay:      '今日宝可梦',
    dailyRenewal:      '每日更新',

    types: {
      fire: '火', water: '水', grass: '草', electric: '电',
      psychic: '超能力', ice: '冰', dragon: '龙', dark: '恶',
      fairy: '妖精', normal: '一般', fighting: '格斗', flying: '飞行',
      poison: '毒', ground: '地面', rock: '岩石', bug: '虫',
      ghost: '幽灵', steel: '钢'
    },

    ficheTitle:        '战略档案：',
    recommendedRole:   '推荐角色',
    natureBuild:       '性格',
    evsBuild:          '努力值',
    itemBuild:         '携带道具',
    weaknesses:        '弱点',
    resistances:       '抵抗',
    immunities:        '无效',

    tierUberDesc:      '压倒性传说',
    tierOUDesc:        '极具竞争力',
    tierUUDesc:        '稳定竞争力',
    tierRUDesc:        '区域使用',
    tierNUDesc:        '人人可用',

    roleAttack:        '物理攻击手',
    roleSpAtk:         '特殊攻击手',
    roleDefense:       '物理防墙',
    roleSpDef:         '特殊防墙',
    roleSpeed:         '速攻手',
    roleHp:            '综合坦克',

    natureJovial:      '固执 (+攻击)',
    natureModeste:     '内敛 (+特攻)',
    natureImpudent:    '大胆 (+防御)',
    natureDoux:        '温和 (+特防)',
    natureTimide:      '胆小 (+速度)',
    naturePrudent:     '谨慎 (+特防)',

    itemCeinture:      '讲究头带',
    itemLunette:       '讲究眼镜',
    itemRestes:        '剩饭',
    itemFoulard:       '讲究围巾',

    statHp:            'HP',
    statAtk:           '攻击',
    statDef:           '防御',
    statSpAtk:         '特攻',
    statSpDef:         '特防',
    statSpeed:         '速度',

    navHome: '首页',
    navPokedex: '图鉴',
    navGames: '小游戏',
    navLegendaries: '传说宝可梦',

    featuresTitle: '选择你的冒险',
    featuresSubtitle: '探索宝可梦世界的多种方式',
    featureSafari: '狩猎区',
    featureSafariDesc: '捕捉野生宝可梦，组建队伍，对战传奇Boss。',
    featurePokedex: '图鉴',
    featurePokedexDesc: '探索超过1000只宝可梦的完整数据库，包括属性、类型和进化。',
    featureQuiz: '宝可梦测验',
    featureQuizDesc: '测试你的知识！轮廓、叫声、类型…你能认出它们全部吗？',
    featureTeamBuilder: '队伍构建器',
    featureTeamBuilderDesc: '构建并优化你的竞技队伍，包括类型分析和协同效应。',
    featureSafariBadge: '空闲RPG',
    featurePokedexBadge: '百科全书',
    featureComingSoon: '即将推出',
    featurePlay: '发现',
    featureSafariStats: '捕捉 & 对战',
    featurePokedexStats: '1000+宝可梦',
    featureQuizStats: '谜题 & 分数',
    featureTeamStats: '策略',

    pokedexPreviewTitle: '图鉴预览',
    pokedexPreviewSubtitle: '{count}只宝可梦等待探索',
    pokedexPreviewButton: '查看所有{count}只宝可梦',

    historyTitle:   '历史记录',
    continueButton: '再玩一次',
    defeatTitle:    '失败',
    pointsGained: '积分 +{points}',
    victoryTitle:   '胜利',

    pokedexKeys: {
      selectGeneration: '选择一代',
      allGenerations: '全部',
      searchPokemon: '搜索宝可梦...',
      noPokemonFound: '未找到宝可梦',
      filterType: '类型',
      filterColor: '颜色',
      sortBy: '排序方式',
      sortNumber: '编号 (ID)',
      sortNameAsc: '名称 (A-Z)',
      sortNameDesc: '名称 (Z-A)',
      sortTotalStatsDesc: '总能力值 (↓)',
      sortTotalStatsAsc: '总能力值 (↑)',
      sortHpDesc: 'HP (↓)',
      sortHpAsc: 'HP (↑)',
      sortAttackDesc: '攻击 (↓)',
      sortAttackAsc: '攻击 (↑)',
      sortDefenseDesc: '防御 (↓)',
      sortDefenseAsc: '防御 (↑)',
      sortSpAtkDesc: '特攻 (↓)',
      sortSpAtkAsc: '特攻 (↑)',
      sortSpDefDesc: '特防 (↓)',
      sortSpDefAsc: '特防 (↑)',
      sortSpeedDesc: '速度 (↓)',
      sortSpeedAsc: '速度 (↑)',
      normal: '一般', fire: '火', water: '水', grass: '草',
      electric: '电', ice: '冰', fighting: '格斗', poison: '毒',
      ground: '地面', flying: '飞行', psychic: '超能力', bug: '虫',
      rock: '岩石', ghost: '幽灵', dragon: '龙', dark: '恶',
      steel: '钢', fairy: '妖精',
      black: '黑色', blue: '蓝色', brown: '棕色', gray: '灰色',
      green: '绿色', pink: '粉色', purple: '紫色', red: '红色',
      white: '白色', yellow: '黄色'
    },

    // GameMenu
    gameModes: '游戏模式',
    gameSubtitle: '测试你的宝可梦知识！',
    
    // shadow
    shadow: '轮廓',
    shadowDesc: '从模糊轮廓猜宝可梦',
    
    // description
    description: '描述',
    
    // type
    type: '属性',
    typeDesc: '通过排除找到所有属性',
    
    // hangman
    hangman: '猜字游戏',
    hangmanDesc: '宝可梦名字猜字游戏',
    
    // memory
    memory: '记忆配对',
    memoryDesc: '配对宝可梦',
    
    // higher-lower
    higherLower: '重量比较',
    higherLowerDesc: '猜哪个宝可梦更重',
    
    // type-challenge
    typeChallenge: '属性挑战',
    typeChallengeDesc: '限时识别属性',
    
    // safarizone
    safariZone: '狩猎区',
    safariZoneDesc: '挂机点击&队伍构建',
    
    // Shared/UI
    descriptionDesc: '暂无描述',
    Quitter: '退出',
    Score: '分数',
    Essais: '尝试次数',
    Valider: '确认',
    Continuer: '继续',
    Rejouer: '再玩一次',

    quitButton: '退出',
    scoreLabel: '分数',
    attemptsLabel: '尝试次数',
    higherLowerTitle: '重还是轻？',
    heavierButton: '更重',
    lighterButton: '更轻',
    vs: '对战',
    retryButton: '重试',
    memoryTitle: '宝可梦记忆',
    pairsLabel: '对子',
    shadowTitle: '影子',
    typeGameTitle: '找出属性',
    toFind: '要找',
    validateButton: '确认',
    loading: '加载中...',
    searchPokemon: '宝可梦名字...', 
    arcadeRetry: '再试一次',
    timeUpMessage: '时间到！ 得分：{score}',
    typeQuestionPrefix: '的属性是 ',
    weightUnit: '千克',

    fp: {
      loading: '正在加载完整数据...',
      error:   '无法加载数据。',

      tab: {
        stats:      '能力值',
        moves:      '招式',
        sprites:    '图像',
        evolution:  '进化',
        pokedex:    '图鉴',
        encounters: '出现地点',
        languages:  '语言',
      },

      stat: {
        hp:               'HP',
        attack:           '攻击',
        defense:          '防御',
        'special-attack': '特攻',
        'special-defense':'特防',
        speed:            '速度',
        total:            '合计',
      },

      qi: {
        height:         '身高',
        weight:         '体重',
        baseExp:        '基础经验值',
        captureRate:    '捕获率',
        baseHappiness:  '基础亲密度',
        growthRate:     '成长速度',
        hatchSteps:     '孵化步数',
        hatchStepsValue:'{steps}步',
        gender:         '性别',
        color:          '颜色',
        shape:          '外形',
        habitat:        '栖息地',
        generation:     '世代',
        evolvesFrom:    '进化前',
        genderDiff:     '性别差异',
        switchableForms:'可变形态',
        yes:            '是',
        colorVal: {
          black: '黑', blue: '蓝', brown: '棕', gray: '灰',
          green: '绿', pink: '粉', purple: '紫', red: '红',
          white: '白', yellow: '黄',
        },
        shapeVal: {
          ball: '球形', squiggle: '蜿蜒', fish: '鱼形',
          arms: '有臂', blob: '团状', upright: '直立',
          legs: '有腿', quadruped: '四足', wings: '有翼',
          tentacles: '触手', heads: '多头', humanoid: '人形',
          'bug-wings': '虫翼', armor: '铠甲',
        },
        habitatVal: {
          cave: '洞穴', forest: '森林', grassland: '草原',
          mountain: '山地', rare: '稀有', 'rough-terrain': '险地',
          sea: '海洋', urban: '城市', 'waters-edge': '水边',
        },
        growthVal: {
          slow: '缓慢', 'medium-slow': '中等偏慢', medium: '中等',
          fast: '较快', 'medium-fast': '中等偏快',
          'slow-then-very-fast': '先慢后极快',
          'fast-then-very-slow': '先快后极慢',
          erratic: '不规则', fluctuating: '波动',
        },
      },

      gender: {
        neutral:   '无性别',
        maleOnly:  '100% 雄性',
        femaleOnly:'100% 雌性',
        ratio:     '♂ {male}% · ♀ {female}%',
      },

      badge: {
        legendary:     '传说 ✨',
        mythical:      '幻之 🌟',
        baby:          '婴儿 🍼',
        hiddenAbility: '隐藏特性',
        babyEvo:       '婴儿',
        default:       '（默认）',
      },

      section: {
        baseStats:       '基础能力值',
        abilities:       '特性',
        breeding:        '培育',
        pastTypes:       '过去的属性',
        pokedexNumbers:  '图鉴编号',
        varieties:       '变种 / 形态',
        palPark:         '伙伴公园',
        gameIndices:     '游戏编号',
        movesTitle:      '招式（共{count}个）',
        sprites:         '图像展示',
        evoChain:        '进化链',
        pokedexDesc:     '图鉴说明',
        cries:           '叫声',
        encountersTitle: '出现地点（{count}处）',
        languagesTitle:  '各语言名称（{count}）',
      },

      breeding: {
        eggGroups:    '蛋组',
        hatchCounter: '孵化周期',
        cycles:       '周期',
        steps:        '步',
      },

      pastTypes: { before: '{gen}世代之前' },
      moves: { level: 'Lv.', move: '招式' },
      palPark: { scoreRate: '分数 {score} · 比率 {rate}' },

      sprite: {
        normal:              '普通',
        back:                '背面',
        shiny:               '色违',
        shinyBack:           '色违背面',
        female:              '雌性',
        femaleBack:          '雌性背面',
        shinyFemale:         '色违雌性',
        officialArtwork:     '官方插图',
        officialArtworkShiny:'色违官方插图',
        home:                'HOME',
        homeShiny:           'HOME 色违',
        showdown:            'Showdown',
        showdownShiny:       'Showdown 色违',
        dreamWorld:          '梦境世界',
      },

      flavor: { noDesc: '该语言/版本暂无说明。' },
      cries: { latest: '当前叫声', legacy: '旧版叫声' },
      encounters: { notWild: '该宝可梦不在野外出现。' },

      evo: {
        level:         'Lv.{level}',
        useItem:       '使用: {item}',
        holdItem:      '携带: {item}',
        trade:         '交换',
        happiness:     '亲密度 ≥ {value}',
        beauty:        '美丽度 ≥ {value}',
        affection:     '亲近度 ≥ {value}',
        knownMove:     '会招式: {move}',
        knownMoveType: '已知属性: {type}',
        location:      '地点: {location}',
        timeOfDay:     '时间段: {time}',
        femaleOnly:    '仅雌性',
        maleOnly:      '仅雄性',
        rain:          '下雨时',
        upsideDown:    '翻转DS',
        partySpecies:  '携带: {species}',
        partyType:     '队伍属性: {type}',
        tradeSpecies:  '与{species}交换',
      },
    },
    classicGameDesc: '一只神秘宝可梦正在躲藏！输入名字来猜猜它是谁。每次尝试都会给你线索：属性、世代、颜色、体型……越接近答案，亮起的格子就越多！',
    classic: {
      won: '{name} — 用了{count}次猜中！',
      col: {
        name:           '宝可梦',
        types:          '属性',
        generation:     '世代',
        color:          '颜色',
        shape:          '外形',
        evolutionStage: '进化阶段',
        height:         '身高',
        weight:         '体重',
      },
      color: {
        black: '黑', blue: '蓝', brown: '棕', gray: '灰',
        green: '绿', pink: '粉', purple: '紫', red: '红',
        white: '白', yellow: '黄',
      },
      shape: {
        ball: '球形', squiggle: '蜿蜒', fish: '鱼形',
        arms: '手臂', blob: '团状', upright: '直立',
        legs: '腿足', quadruped: '四足', wings: '有翼',
        tentacles: '触手', heads: '多头', humanoid: '人形',
        'bug-wings': '虫翼', armor: '铠甲',
      },
      hint: {
        title:          '해금된 힌트',
        firstLetter:    '이름의 첫 글자',
        type:           '주요 타입',
        generation:     '세대',
        evolutionStage: '진화 단계',
        cry:            '포켓몬 울음소리',
        silhouette:     '실루엣',
        next:           '다음 힌트까지 {remaining}번 남음',
      },
    },
    authModal:{
      loginTitle: '登入',
      registerTitle: '註冊',
      forgotTitle: '忘記密碼？',
      usernameLabel: '用戶名',
      emailLabel: '電子郵件',
      passwordLabel: '密碼',
      usernamePlaceholder: '選擇訓練家名',
      emailPlaceholder: 'pokemon@master.com',
      passwordPlaceholder: '你的密碼',
      submitLogin: '抓到全部！',
      submitRegister: '建立隊伍',
      submitting: '捕獲中...',
      sendReset: '發送重置連結',
      sending: '發送中...',
      backToLogin: '← 返回登入',
      forgotPassword: '忘記密碼？',
      createAccount: '建立帳戶',
      loginInstead: '登入',
      noAccount: '還沒有隊伍？',
      hasAccount: '已經是訓練家？',
      emailRequired: '電子郵件必填',
      emailInvalid: '無效電子郵件',
      passwordRequired: '密碼必填',
      passwordMin: '最少6字元',
      usernameMin: '用戶名最少3字元',
      emailNotFound: '電子郵件未找到',
      requestTimeout: '請求逾時(10秒)',
      networkError: '網路錯誤。請檢查連線。',
      generalError: '請求錯誤',
      resetSent: '重置連結已發送！檢查信箱。',
      showPassword: '顯示密碼',
      hidePassword: '隱藏密碼',
    },
    resetPassword: {
      title: '重置密码',
      emailLabel: '邮箱',
      emailPlaceholder: 'your@email.com',
      newPasswordLabel: '新密码',
      newPasswordPlaceholder: '新密码（最低6位）',
      confirmLabel: '确认',
      confirmPlaceholder: '确认密码',
      submitButton: '重置',
      submitting: '重置中...',
      closeButton: '关闭',
      passwordMismatch: '密码不匹配',
      passwordTooShort: '密码太短（最低6位）',
      successMessage: '密码重置成功！正在跳转...',
      resetError: '重置失败',
    },
  },
};

export const t = (key, language, vars = {}) => {
  
  let lang = language?.toLowerCase() || 'fr';
  if (lang === 'zh' || lang.startsWith('zh-h')) lang = 'zh-Hans';

  const getNestedValue = (obj, path) => {
    const parts = path.split('.');
    return parts.reduce((current, part) => current?.[part], obj);
  };

  let translation = getNestedValue(translations[lang]?.pokedexKeys, key) ||
                   getNestedValue(translations[lang], key) || 
                   getNestedValue(translations.fr?.pokedexKeys, key) ||
                   getNestedValue(translations.fr, key) || key;

  Object.entries(vars).forEach(([placeholder, value]) => {
    translation = translation.replace(new RegExp(`\\{${placeholder}\\}`, 'g'), value);
  });
  
  return translation;
};

